import React, { useState, useEffect, useRef, useCallback } from "react";
import "../styles/EDCCProfile.css";
import "../styles/EDCCCertificate.css";
import "../styles/EDCCReport.css";
import "../styles/EDCCInvoice.css";
import {
  ChevronUp,
  ChevronDown,
  Lock,
  Download,
  FileText,
  FileSearch,
  Award,
} from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  loadRazorpayScript,
  createOrder,
  openRazorpayCheckout,
  verifyPayment,
  calculateEDCCPricing,
  formatIndianCurrency,
} from "../utils/razorpay";
import {
  generateReceiptPDF,
  generateReportPDF,
  generateCertificatePDF,
  openReceiptPDF,
  openReportPDF,
  openCertificatePDF,
} from "../utils/pdfGenerator";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Card,
  Modal,
} from "react-bootstrap";
import heroBg from "../assets/images/HeroBanner.png";
import html2pdf from "html2pdf.js";
import certificateBg from "../assets/images/EDCCCertificateBg.png";
import presidentSign from "../assets/images/presidentSignEdcc.jpg";

const EDCCProfilePage = () => {
  const sectionRefs = useRef([]);
  const [selectedSection, setSelectedSection] = useState(
    () => localStorage.getItem("selectedSectionEDCC") || "EDCC Login Process"
  );

  const navigate = useNavigate();

  useEffect(() => {
    localStorage.setItem("selectedSectionEDCC", selectedSection);
  }, [selectedSection]);
  // Add this with your other state declarations
const [paymentLoading, setPaymentLoading] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [edccData, setEdccData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentStep, setCurrentStep] = useState(1); // 1: Registration, 1.5: Verification Under Process, 2: Verification Completed, 2.5: Payment Process, 3: Inspection, 3.5: Inspection Completed, 4: Certificate Issued
  const [verificationMessage, setVerificationMessage] = useState("");
  const [verificationNote, setVerificationNote] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [editingData, setEditingData] = useState(null);
  // Add these with your other state declarations new cange
  const [splitPayments, setSplitPayments] = useState([]);
  const [currentSplitIndex, setCurrentSplitIndex] = useState(0);
  const [isSplitPaymentFlow, setIsSplitPaymentFlow] = useState(false);
  const [isRenewalMode, setIsRenewalMode] = useState(false);
  const [renewalConsentChecked, setRenewalConsentChecked] = useState(false);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [passwordError, setPasswordError] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");
  const [passwordLoading, setPasswordLoading] = useState(false);
  const [showSignOutModal, setShowSignOutModal] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [showMissingDocsModal, setShowMissingDocsModal] = useState(false);
  const [missingDocsList, setMissingDocsList] = useState([]);
  const [allMembers, setAllMembers] = useState(null);
  const [countryOptions, setCountryOptions] = useState([]);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [factoryStateOptions, setFactoryStateOptions] = useState([]);
  const [factoryDistrictOptions, setFactoryDistrictOptions] = useState([]);
// Add this with your other state declarations
const [renewalInspectionReportFile, setRenewalInspectionReportFile] = useState(null);
const [uploadingRenewalReport, setUploadingRenewalReport] = useState(false);
const [renewalInspectionReports, setRenewalInspectionReports] = useState([]);
  const [subItemInputs, setSubItemInputs] = useState({});
  const location = useLocation();
  const baseUrl = process.env.REACT_APP_BASEURL;
  const baseUrlRole = process.env.REACT_APP_API_BASE_ROLE;

  const edccFeeRupees = Number(process.env.REACT_APP_EDCC_FEE || 1);

  const getEntityId = (entity) => {
    if (!entity) return "";
    if (typeof entity === "object") {
      return (
        entity._id ||
        entity.id ||
        entity.value ||
        entity.country_id ||
        entity.state_id ||
        entity.district_id ||
        ""
      );
    }
    return entity;
  };
const handleRenewalInspectionReportUpload = async () => {
  try {
    if (!renewalInspectionReportFile) {
      alert("Please select a file to upload");
      return;
    }

    const user = JSON.parse(localStorage.getItem("user")) || location.state?.user;
    const token = localStorage.getItem("token") || location.state?.token;

    if (!user || !token) {
      alert("User not authenticated");
      return;
    }

    setUploadingRenewalReport(true);

    const formData = new FormData();
    formData.append("inspection_report", renewalInspectionReportFile);
    formData.append("uploaded_by", user._id);
const response = await axios.post(
      `${baseUrl}/edcc/${edccData._id}/upload-renewal-inspection-report`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.data.success) {
      // Update local state with new report
      const updatedData = response.data.data;
      
      setEdccData(prev => ({
        ...prev,
        renewal_inspection_report: updatedData.renewal_inspection_report || []
      }));
      const newReport = {
        report_url: response.data.data.latest_inspection_report,
        uploaded_at: new Date(),
        inspection_date: new Date(),
        notes: "Renewal inspection report uploaded"
      };
      
      // setRenewalInspectionReports(prev => [...prev, newReport]);
      setRenewalInspectionReportFile(null);
      
      // Show success message
      const alertDiv = document.createElement('div');
      alertDiv.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: white;
        padding: 30px 40px;
        border-radius: 12px;
        box-shadow: 0 10px 40px rgba(0,0,0,0.3);
        z-index: 10000;
        max-width: 500px;
        text-align: center;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      `;
      
      alertDiv.innerHTML = `
        <div style="margin: 0 0 20px 0; color: #28a745; font-size: 48px;">
          ✓
        </div>
        <h3 style="margin: 0 0 15px 0; color: #333; font-size: 22px; font-weight: 600;">
          Renewal Inspection Report Uploaded Successfully!
        </h3>
        <p style="margin: 0 0 25px 0; color: #666; font-size: 16px; line-height: 1.5;">
          Your renewal inspection report has been uploaded and is ready for review.
        </p>
        <button onclick="this.parentElement.remove(); document.getElementById('overlay-backdrop').remove();" 
          style="background: #007bff; color: white; border: none; padding: 10px 30px; 
          border-radius: 6px; font-size: 16px; cursor: pointer; font-weight: 500;">
          OK
        </button>
      `;
      
      const backdrop = document.createElement('div');
      backdrop.id = 'overlay-backdrop';
      backdrop.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.5);
        z-index: 9999;
      `;
      backdrop.onclick = () => {
        alertDiv.remove();
        backdrop.remove();
      };
      
      document.body.appendChild(backdrop);
      document.body.appendChild(alertDiv);
    }
  } catch (error) {
    console.error("Error uploading renewal inspection report:", error);
    alert(`Error uploading report: ${error.response?.data?.message || error.message}`);
  } finally {
    setUploadingRenewalReport(false);
  }
};



// const fetchRenewalInspectionReports = async () => {
//   try {
//     const user = JSON.parse(localStorage.getItem("user")) || location.state?.user;
//     const token = localStorage.getItem("token") || location.state?.token;

//     if (!user || !token || !edccData?._id) return;

//     const response = await axios.get(
//       `${baseUrl}/edcc/${edccData._id}/renewal-inspection-reports`,
//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       }
//     );

//     if (response.data.success) {
//       setRenewalInspectionReports(response.data.data.reports || []);
//     }
//   } catch (error) {
//     console.error("Error fetching renewal inspection reports:", error);
//   }
// };



  const fetchCountries = useCallback(async () => {
    if (!baseUrl) {
      console.warn("Base URL is not configured. Unable to fetch countries.");
      setCountryOptions([]);
      return [];
    }
    try {
      const response = await axios.get(`${baseUrl}/countries`);
      if (Array.isArray(response.data?.data)) {
        setCountryOptions(response.data.data);
        return response.data.data;
      }
      if (Array.isArray(response.data)) {
        setCountryOptions(response.data);
        return response.data;
      }
      setCountryOptions([]);
      return [];
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCountryOptions([]);
      return [];
    }
  }, [baseUrl]);

  const fetchStates = useCallback(
    async (countryId) => {
      if (!baseUrl || !countryId) {
        return [];
      }
      try {
        const response = await axios.get(`${baseUrl}/states/${countryId}`);
        if (Array.isArray(response.data?.data)) {
          return response.data.data;
        }
        if (Array.isArray(response.data)) {
          return response.data;
        }
      } catch (error) {
        console.error("Error fetching states:", error);
      }
      return [];
    },
    [baseUrl]
  );

  const fetchDistricts = useCallback(
    async (countryId, stateId) => {
      if (!baseUrl || !countryId || !stateId) {
        return [];
      }
      try {
        const response = await axios.get(
          `${baseUrl}/districts/${countryId}/${stateId}`
        );
        if (Array.isArray(response.data?.data)) {
          return response.data.data;
        }
        if (Array.isArray(response.data)) {
          return response.data;
        }
      } catch (error) {
        console.error("Error fetching districts:", error);
      }
      return [];
    },
    [baseUrl]
  );

  useEffect(() => {
    fetchCountries();
  }, [fetchCountries]);

  const officeCountryId = getEntityId(editingData?.country);
  const officeStateId = getEntityId(editingData?.state);
  const factoryCountryId = getEntityId(editingData?.Co_country);
  const factoryStateId = getEntityId(editingData?.Co_state);

  useEffect(() => {
    let isMounted = true;
    if (isEditing && officeCountryId) {
      setStateOptions([]);
      fetchStates(officeCountryId).then((data) => {
        if (isMounted) {
          setStateOptions(data);
        }
      });
    } else {
      setStateOptions([]);
    }
    return () => {
      isMounted = false;
    };
  }, [isEditing, officeCountryId, fetchStates]);

  useEffect(() => {
    let isMounted = true;
    if (isEditing && officeCountryId && officeStateId) {
      setDistrictOptions([]);
      fetchDistricts(officeCountryId, officeStateId).then((data) => {
        if (isMounted) {
          setDistrictOptions(data);
        }
      });
    } else {
      setDistrictOptions([]);
    }
    return () => {
      isMounted = false;
    };
  }, [isEditing, officeCountryId, officeStateId, fetchDistricts]);

  useEffect(() => {
    let isMounted = true;
    if (isEditing && factoryCountryId) {
      setFactoryStateOptions([]);
      fetchStates(factoryCountryId).then((data) => {
        if (isMounted) {
          setFactoryStateOptions(data);
        }
      });
    } else {
      setFactoryStateOptions([]);
    }
    return () => {
      isMounted = false;
    };
  }, [isEditing, factoryCountryId, fetchStates]);

  useEffect(() => {
    let isMounted = true;
    if (isEditing && factoryCountryId && factoryStateId) {
      setFactoryDistrictOptions([]);
      fetchDistricts(factoryCountryId, factoryStateId).then((data) => {
        if (isMounted) {
          setFactoryDistrictOptions(data);
        }
      });
    } else {
      setFactoryDistrictOptions([]);
    }
    return () => {
      isMounted = false;
    };
  }, [isEditing, factoryCountryId, factoryStateId, fetchDistricts]);

  const finalCertificateIssuedDate = edccData?.final_certificate_issued_date
    ? new Date(edccData.final_certificate_issued_date)
    : edccData?.inspection_date
    ? new Date(edccData.inspection_date)
    : null;

  const calculatedValidityDate = (() => {
    if (edccData?.valid_till) {
      return new Date(edccData.valid_till);
    }
    if (finalCertificateIssuedDate) {
      const expiry = new Date(finalCertificateIssuedDate);
      expiry.setFullYear(expiry.getFullYear() + 1);
      return expiry;
    }
    return null;
  })();

  const handleDownloadFile = async (url, filename = "document.pdf") => {
    if (!url) return;
    try {
      const response = await fetch(url, { mode: "cors" });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      // Fallback: may open in new tab for some hosts, but better than failing silently
      console.error("Download failed, falling back to direct link:", error);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.target = "_self";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const fetchAdminAllMembers = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Authentication token not found. Please login again.");
      }
      const API_BASE_URL =
        process.env.REACT_APP_BASEURL || "http://localhost:4890";
      const response = await fetch(`${API_BASE_URL}/getall`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      let membersData;
      if (Array.isArray(result)) {
        membersData = result;
      } else if (result.data && Array.isArray(result.data)) {
        membersData = result.data;
      } else {
        throw new Error("Unexpected response format from /getall");
      }
      setAllMembers(membersData); // Store in state
      return membersData;
    } catch (error) {
      console.error("Error fetching admin all members data:", error.message);
      setAllMembers(null);
      return null;
    }
  };
  useEffect(() => {
    fetchAdminAllMembers();
  }, []);

  const handleSignOut = () => {
    setShowSignOutModal(true);
  };

  const handleSignOutConfirm = () => {
    setIsLoggingOut(true);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setShowSignOutModal(false);
    // window.location.href = "/";
    navigate("/");
  };

  const handleSignOutCancel = () => {
    setShowSignOutModal(false);
  };

  const changePasswordAPI = async (passwordData) => {
    const token = localStorage.getItem("token") || location.state?.token;
    if (!token) {
      throw new Error("Authentication token not found. Please login again.");
    }
    const response = await axios.put(
      `${baseUrlRole}/user-change-password`,
      passwordData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.data) {
      throw new Error(response.data.message || "Failed to change password");
    }
    return response.data;
  };

  const validatePasswordForm = () => {
    if (
      !passwordData.currentPassword ||
      !passwordData.newPassword ||
      !passwordData.confirmPassword
    ) {
      setPasswordError("All fields are required.");
      return false;
    }
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setPasswordError("New password and confirm password do not match.");
      return false;
    }
    if (passwordData.newPassword.length < 8) {
      setPasswordError("Password must be at least 8 characters long.");
      return false;
    }
    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/.test(
        passwordData.newPassword
      )
    ) {
      setPasswordError(
        "Password must contain uppercase, lowercase, number and special character."
      );
      return false;
    }
    if (passwordData.currentPassword === passwordData.newPassword) {
      setPasswordError("New password must be different from current password.");
      return false;
    }
    return true;
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPasswordError("");
    setPasswordSuccess("");
    if (!validatePasswordForm()) {
      return;
    }
    setPasswordLoading(true);
    try {
      const data = {
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword,
        confirmPassword: passwordData.confirmPassword,
      };
      const response = await changePasswordAPI(data);
      setPasswordSuccess(response.message || "Password changed successfully!");
      setPasswordData({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
      setTimeout(() => {
        setPasswordSuccess("");
        setSelectedSection("EDCC Login Process");
      }, 2000);
    } catch (error) {
      console.error("Error changing password:", error);
      setPasswordError(
        error.message || "Failed to change password. Please try again."
      );
    } finally {
      setPasswordLoading(false);
    }
  };

  // Fetch EDCC data when component mounts
  useEffect(() => {
    const fetchEDCCData = async () => {
      try {
        // Get user data from localStorage or location state
        const user =
          JSON.parse(localStorage.getItem("user")) || location.state?.user;
        const token = localStorage.getItem("token") || location.state?.token;

        if (!user || !token) {
          setError("User not authenticated");
          setLoading(false);
          return;
        }

        // Check if user has EDCC role and details_id
        console.log("User object:", user);
        console.log("User role:", user.rolename);
        console.log("User details_id:", user.details_id);

        if (user.rolename !== "EDCC" || !user.details_id) {
          setError("User not authorized for EDCC access or missing details");
          setLoading(false);
          return;
        }

        // Fetch EDCC data using the details_id from user object
        let response;
        try {
          response = await axios.get(
            `${baseUrl}/getEDCCById/${user.details_id}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
        } catch (detailsError) {
          // If details_id endpoint doesn't exist, try to get by user ID as fallback
          if (user._id) {
            response = await axios.get(`${baseUrl}/getEDCCById/${user._id}`, {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            });
          } else {
            throw detailsError;
          }
        }

       if (response.data.success) {
  const data = response.data.data;
  console.log("EDCC Data fetched successfully:", data);
  setEdccData(data);
  // if (data.is_renewal_requested === "requested") {
  //         await fetchRenewalInspectionReports();
  //       }
        
          // Determine current step and messages based on boolean flags
          const {
            is_verified,
            is_payment_done,
            is_payment_checked,
            is_inspected,
            final_certificate_issued,
            is_rejected,
            rejection_reason,
            rejection_details,
            is_renewal_requested,
            is_renewed_verified,
            is_renewed_payment_done,
            is_renewed_payment_checked,
            is_renewed_inspected,
            is_renewed_certificates_issued,
            renewal_inspection_report,
          } = data;

          // Logic for determining current step and messages
          // Update in useEffect around line 106
          if (is_rejected) {
            // Rejection case - determine which step was rejected
            let rejectionStep = 1.5; // Default to verification step
            let rejectionMessage = "Verification Not Completed";

            if (rejection_details?.rejected_step) {
              switch (rejection_details.rejected_step) {
                case "docVerification":
                  rejectionStep = 1.5;
                  rejectionMessage = "Verification Not Completed";
                  break;
                case "PaymentVerification":
                  rejectionStep = 2.5;
                  rejectionMessage = "Payment Verification Failed";
                  break;
                case "Inspection":
                  rejectionStep = 3.5;
                  rejectionMessage = "Inspection Not Completed";
                  break;
                default:
                  rejectionStep = 1.5;
                  rejectionMessage = "Verification Not Completed";
              }
            }

            setCurrentStep(rejectionStep);
            setVerificationMessage(rejectionMessage);
            setVerificationNote(
              rejection_reason
                ? `Note: ${rejection_reason}`
                : "Note: Your application has been rejected. Please review and resubmit."
            );
            // Keep on EDCC Login Process section
            setSelectedSection("EDCC Login Process");
          } else if (!is_verified) {
            // Initial state after registration
            setCurrentStep(1.5);
            setVerificationMessage("Verification Under Process");
            setVerificationNote(
              "Note: Your application is currently under review. Please wait for verification."
            );
          } else if (is_verified && !is_payment_done) {
            // Verification completed, waiting for payment
            setCurrentStep(2);
            setVerificationMessage("Waiting for Payment Approval");
            setVerificationNote("Your payment status is being processed by the treasurer");
          } else if (is_payment_done && !is_payment_checked) {
            // Payment done, waiting for treasurer verification
            setCurrentStep(2.5);
            setVerificationMessage("Waiting for Payment Approval");
            setVerificationNote(
              "Your payment is being verified by the treasurer"
            );
          } else if (is_payment_checked && !is_inspected) {
            // Payment verified, waiting for inspection
            setCurrentStep(3);
            setVerificationMessage("Payment Successfully Verified");
            setVerificationNote("Inspection will be scheduled");
          } else if (is_inspected && !final_certificate_issued) {
            // Inspection completed, waiting for certificate
            setCurrentStep(3.5);
            setVerificationMessage("Inspection Completed");
            setVerificationNote("Report Submitted");
          } else if (final_certificate_issued) {
            // Check if renewal process has started using is_renewal_requested
            if (is_renewal_requested && is_renewal_requested !== "pending") {
              // Check renewal status
              if (is_rejected) {
                // Renewal rejection case - use same is_rejected as registration
                let renewalRejectionStep = 1.5;
                let renewalRejectionMessage =
                  "Renewal Verification Not Completed";

                if (rejection_details?.rejected_step) {
                  switch (rejection_details.rejected_step) {
                    case "docVerification":
                      renewalRejectionStep = 1.5;
                      renewalRejectionMessage =
                        "Renewal Verification Not Completed";
                      break;
                    case "PaymentVerification":
                      renewalRejectionStep = 2.5;
                      renewalRejectionMessage =
                        "Renewal Payment Verification Failed";
                      break;
                    case "Inspection":
                      renewalRejectionStep = 3.5;
                      renewalRejectionMessage =
                        "Renewal Inspection Not Completed";
                      break;
                    default:
                      renewalRejectionStep = 1.5;
                      renewalRejectionMessage =
                        "Renewal Verification Not Completed";
                  }
                }

                setCurrentStep(renewalRejectionStep);
                setVerificationMessage(renewalRejectionMessage);
                setVerificationNote(
                  rejection_reason ||
                    "Note: Your renewal application has been rejected. Please review and resubmit."
                );
              } else if (!is_renewed_verified) {
                // Renewal submitted, waiting for verification
                setCurrentStep(1.5);
                setVerificationMessage("Renewal Verification Under Process");
                setVerificationNote(
                  "Note: Your renewal application is currently under review. Please wait for verification."
                );
              } else if (is_renewed_verified && !is_renewed_payment_done) {
                // Renewal verified, waiting for payment
                setCurrentStep(2);
                setVerificationMessage("Waiting for Renewal Payment Approval");
                setVerificationNote("Your renewal payment status is being processed by the treasurer");
              } else if (
                is_renewed_payment_done &&
                !is_renewed_payment_checked
              ) {
                // Renewal payment done, waiting for treasurer verification
                setCurrentStep(2.5);
                setVerificationMessage("Waiting for Renewal Payment Approval");
                setVerificationNote(
                  "Your renewal payment is being verified by the treasurer"
                );
              } else if (is_renewed_payment_checked && !is_renewed_inspected) {
                // Renewal payment verified, waiting for inspection
                setCurrentStep(3);
                setVerificationMessage("Renewal Payment Successfully Verified");
                setVerificationNote("Renewal inspection will be scheduled");
              } else if (
                is_renewed_inspected &&
                !is_renewed_certificates_issued
              ) {
                // Renewal inspection completed, waiting for certificate
                setCurrentStep(3.5);
                setVerificationMessage("Renewal Inspection Completed");
                setVerificationNote("Renewal report submitted");
              } else if (is_renewed_certificates_issued) {
                // Renewal certificate issued
                setCurrentStep(4);
                setVerificationMessage("Renewal Certificate Issued");
                setVerificationNote("Your renewal process is complete");
              }
            } else {
              // Final certificate issued but no renewal started
              setCurrentStep(4);
              setVerificationMessage("Certificate Issued");
              setVerificationNote("Your certification process is complete");
            }
          } else {
            // Default case
            setCurrentStep(1);
            setVerificationMessage("Registration Completed");
            setVerificationNote("");
          }
        } else {
          // If no EDCC data found, user is newly registered
          setCurrentStep(1);
          setVerificationMessage("Registration Completed");
          setVerificationNote("");
          setEdccData(null);
        }
      } catch (error) {
        console.error("Error fetching EDCC data:", error);
        console.error("Error response:", error.response);

        if (error.response?.status === 404) {
          // User not found - newly registered
          setCurrentStep(1);
          setVerificationMessage("Registration Completed");
          setVerificationNote("");
          setEdccData(null);
        } else if (error.response?.status === 401) {
          setError("Authentication failed. Please login again.");
        } else if (error.response?.status === 403) {
          setError("Access denied. User not authorized for EDCC.");
        } else {
          setError(
            `Failed to fetch EDCC data: ${
              error.response?.data?.message || error.message
            }`
          );
        }
      } finally {
        setLoading(false);
      }
    };

    fetchEDCCData();
  }, [baseUrl, location]);

  const toggleAccordion = (accordion, index) => {
    const newActiveAccordion = activeAccordion === accordion ? null : accordion;
    setActiveAccordion(newActiveAccordion);
    if (newActiveAccordion !== null) {
      handleAccordionClick(index);
    }
  };

  const handleAccordionClick = (index) => {
    const section = sectionRefs.current[index];
    if (!section) return;

    // Wait for the accordion animation (if any)
    setTimeout(() => {
      section.focus();

      const headerOffset = 120; // adjust this to match your fixed header height
      const elementPosition =
        section.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }, 400); // wait for expand animation to finish
  };

  // Check if a section is clickable based on current step
  const isSectionClickable = (sectionName) => {
    switch (sectionName) {
      case "EDCC Login Process":
        return true;
      case "Registration":
        return currentStep >= 1;
      case "Receipts": {
        const renewedReceipts =
          edccData?.renewedEdccReceipts ||
          edccData?.renewed_edcc_receipts ||
          edccData?.renewed_edcc_receipt ||
          [];
        return !!edccData?.receipt_certificate || renewedReceipts.length > 0;
      }
      case "Reports":
       return !!edccData?.inspection_report || 
             edccData?.is_renewal_requested === "requested"; // now based on existence of stored report
      case "Certificates": {
        const renewedCerts = (
          edccData?.renewedEdccCertificates ||
          edccData?.renewed_edcc_certificates ||
          edccData?.renewed_edccCertificates ||
          []
        ).filter((cert) => !cert?.isDeleted);
        const edccCerts = (edccData?.edccCertificates || []).filter(
          (cert) => !cert?.isDeleted
        );
        return edccCerts.length > 0 || renewedCerts.length > 0;
      }
      case "Renewal":
        return currentStep >= 4;
      case "Change Password":
        return true;
      default:
        return false;
    }
  };

  // Handle section click
  const handleSectionClick = (sectionName) => {
    if (sectionName !== "Renewal") {
      setIsRenewalMode(false);
    }

    if (isSectionClickable(sectionName)) {
      setSelectedSection(sectionName);
    }
  };

  const handleCountrySelection = (countryId) => {
    if (!isEditing) return;
    const selectedCountry = countryOptions.find((c) => c._id === countryId);
    setEditingData((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        country: countryId
          ? {
              _id: countryId,
              country_name: selectedCountry?.country_name || "",
            }
          : "",
        state: "",
        district: "",
      };
    });
  };

  const handleStateSelection = (stateId) => {
    if (!isEditing) return;
    const selectedState = stateOptions.find((s) => s._id === stateId);
    setEditingData((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        state: stateId
          ? { _id: stateId, state_name: selectedState?.state_name || "" }
          : "",
        district: "",
      };
    });
  };

  const handleDistrictSelection = (districtId) => {
    if (!isEditing) return;
    const selectedDistrict = districtOptions.find((d) => d._id === districtId);
    setEditingData((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        district: districtId
          ? {
              _id: districtId,
              district_name: selectedDistrict?.district_name || "",
            }
          : "",
      };
    });
  };

  const handleFactoryCountrySelection = (countryId) => {
    if (!isEditing) return;
    const selectedCountry = countryOptions.find((c) => c._id === countryId);
    setEditingData((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        Co_country: countryId
          ? {
              _id: countryId,
              country_name: selectedCountry?.country_name || "",
            }
          : "",
        Co_state: "",
        Co_district: "",
      };
    });
  };

  const handleFactoryStateSelection = (stateId) => {
    if (!isEditing) return;
    const selectedState = factoryStateOptions.find((s) => s._id === stateId);
    setEditingData((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        Co_state: stateId
          ? { _id: stateId, state_name: selectedState?.state_name || "" }
          : "",
        Co_district: "",
      };
    });
  };

  const handleFactoryDistrictSelection = (districtId) => {
    if (!isEditing) return;
    const selectedDistrict = factoryDistrictOptions.find(
      (d) => d._id === districtId
    );
    setEditingData((prev) => {
      if (!prev) return prev;
      return {
        ...prev,
        Co_district: districtId
          ? {
              _id: districtId,
              district_name: selectedDistrict?.district_name || "",
            }
          : "",
      };
    });
  };
  // Add these new functions before handleProceedToPayment
  const handleSplitPayment = async (totalAmount) => {
    const MAX_AMOUNT = 100000; // ₹1,00,000 limit
    const payments = [];
    let remainingAmount = totalAmount;

    while (remainingAmount > 0) {
      const paymentAmount = Math.min(remainingAmount, MAX_AMOUNT);
      payments.push({
        amount: paymentAmount,
        paid: false,
        orderId: null,
        paymentId: null,
      });
      remainingAmount -= paymentAmount;
    }

    setSplitPayments(payments);
    setCurrentSplitIndex(0);
    setIsSplitPaymentFlow(true);

    // Start the first payment
    await processNextSplitPayment(payments, 0);
  };

  const processNextSplitPayment = async (payments, index) => {
    try {
      const user =
        JSON.parse(localStorage.getItem("user")) || location.state?.user;
      const token = localStorage.getItem("token") || location.state?.token;

      if (!user || !token) {
        alert("User not authenticated");
        return;
      }

      const currentPayment = payments[index];
      const totalPayments = payments.length;

      // Create order for current split
      const orderResp = await createOrder({
        baseUrl,
        token,
        amountInRupees: currentPayment.amount,
        products: edccData?.range_of_products || [],
        notes: {
          details_id: user?.details_id || "",
          split_payment: {
            part: index + 1,
            total_parts: totalPayments,
            total_amount: payments.reduce((sum, p) => sum + p.amount, 0),
          },
        },
      });

      // Open Razorpay checkout for current split
      openRazorpayCheckout({
        order: orderResp?.data,
        name: "AIOTA - EDCC Certification",
        description: `Payment ${
          index + 1
        }/${totalPayments} - EDCC Certification`,
        prefill: {
          name: user?.name || "",
          email: user?.email || "",
          contact: edccData?.mobile_number || "",
        },
        notes: {
          module: "EDCC",
          split_payment: `Part ${index + 1} of ${totalPayments}`,
        },
        onSuccess: async (response) => {
          try {
            // Verify payment
            const verifyResp = await verifyPayment({
              baseUrl,
              payload: {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                membership_type: "EDCC",
                member_id: user._id,
              },
            });

            if (verifyResp?.success) {
              // Update the split payment status
              const updatedPayments = [...payments];
              updatedPayments[index] = {
                ...currentPayment,
                paid: true,
                orderId: response.razorpay_order_id,
                paymentId: response.razorpay_payment_id,
              };
              setSplitPayments(updatedPayments);

              // If all payments are complete
              if (index === totalPayments - 1) {
                // Update EDCC status with all payment details
                await axios.put(
                  `${baseUrl}/updateEDCC/${user.details_id}`,
                  {
                    is_payment_done: true,
                    payment_details: {
                      split_payments: updatedPayments,
                      total_amount: payments.reduce(
                        (sum, p) => sum + p.amount,
                        0
                      ),
                      completed_at: new Date().toISOString(),
                    },
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-Type": "application/json",
                    },
                  }
                );

                setIsSplitPaymentFlow(false);
                setCurrentSplitIndex(0);
                setSplitPayments([]);
                setCurrentStep(2.5);
                setVerificationMessage("All Payments Successfully Completed");
                setVerificationNote("Inspection will be scheduled");
              } else {
                // Process next split payment
                setCurrentSplitIndex(index + 1);
                await processNextSplitPayment(updatedPayments, index + 1);
              }
            } else {
              alert("Payment verification failed. Please contact support.");
            }
          } catch (err) {
            console.error("Payment verification error:", err);
            alert("Payment verification failed. Please contact support.");
          }
        },
        onFailure: (err) => {
          console.error("Payment failed:", err);
          alert(
            `Payment ${index + 1}/${totalPayments} failed: ${
              err?.message || "Payment was not completed."
            }`
          );
        },
      });
    } catch (err) {
      console.error("Split payment processing error:", err);
      alert("Unable to process payment. Please try again later.");
    }
  };

  const handleProceedToPayment = async () => {
    try {
      setLoading(true);

      const user =
        JSON.parse(localStorage.getItem("user")) || location.state?.user;
      const token = localStorage.getItem("token") || location.state?.token;

      if (!user || !token) {
        alert("User not authenticated");
        setLoading(false);
        return;
      }

      // Determine if this is renewal or regular payment based on is_renewal_requested
      const isRenewalPayment =
        edccData?.is_renewal_requested &&
        edccData.is_renewal_requested !== "pending";

      const endpoint = isRenewalPayment
        ? `${baseUrl}/edcc/${user.details_id}/set-renewed-payment-done`
        : `${baseUrl}/edcc/${user.details_id}/set-payment-done`;

      const response = await axios.put(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data?.success) {
        throw new Error(
          response.data?.message || "Failed to update payment status"
        );
      }

      if (isRenewalPayment) {
        setEdccData((prev) => ({
          ...prev,
          is_renewed_payment_done: true,
        }));
        setCurrentStep(2.5);
        setVerificationMessage("Waiting for Renewal Payment Approval");
        setVerificationNote(
          "Your renewal payment status is being processed by the treasurer"
        );
      } else {
        setEdccData((prev) => ({
          ...prev,
          is_payment_done: true,
        }));
        setCurrentStep(2.5);
        setVerificationMessage("Waiting for Payment Approval");
        setVerificationNote(
          "Your payment status is being processed by the treasurer"
        );
      }
    } catch (err) {
      console.error("Payment status update error:", err);
      const errorMessage = err.response?.data?.message || err.message;
      alert(
        `Unable to update payment status: ${errorMessage}. Please try again later.`
      );
    } finally {
      setLoading(false);
    }
  };

  // Advance to next step after backend marks payment checked
  const handlePaymentCompleted = () => {
    setCurrentStep(3);
    setVerificationMessage("Payment Successfully Completed");
    setVerificationNote("Inspection will be scheduled");
  };

  // Handle edit mode toggle
  const handleEditToggle = () => {
    if (!isEditing) {
      // Starting edit mode - create a copy of current data
      const editData = { ...edccData };

      // Keep the original file references
      const fileFields = [
        "details_of_machineries",
        "upload_signature",
        "company_seal",
        "lease_agreement",
        "electricity_bill",
        "gst_certificate",
        "pan_certificate",
        "acknowledgement_certificate",
        "unit_registration_certificate",
        "list_of_machines",
        "copy_certificates",
        "ca_certificate",
      ];

      fileFields.forEach((field) => {
        if (editData[field]) {
          editData[field] = {
            name: editData[field].split("/").pop(),
            url: editData[field],
          };
        }
      });

      setEditingData(editData);

      // If we're on EDCC Login Process page and editing, redirect to Registration
      if (selectedSection === "EDCC Login Process") {
        setSelectedSection("Registration");
      }
    }
    setIsEditing(!isEditing);
  };

  // Handle renewal mode toggle
 const handleRenewalToggle = () => {
  if (!isRenewalMode) {
    // Proceed with renewal without validity restrictions

      // Starting renewal mode - create a copy of current data and enable product selection
      const renewalData = { ...edccData };

      // Initialize renewal range of products with current products selected
      if(edccData.renewed_range_of_products?.length === 0) {
        // Carry over existing products but mark them as requested ONLY if they need renewal
        renewalData.renewed_range_of_products = (edccData?.range_of_products || []).map(p => {
          const heading = typeof p === 'object' ? p.heading : p;
          const validity = getProductValidityStatus(heading);
          return {
            ...(typeof p === 'object' ? p : { heading: p }),
            is_requested: !validity.isStillValid,
          };
        });
      } else {
        // Carry over pre-existing renewed products but mark them as requested ONLY if they need renewal
        renewalData.renewed_range_of_products = (edccData.renewed_range_of_products || []).map(p => {
          const heading = typeof p === 'object' ? p.heading : p;
          const validity = getProductValidityStatus(heading);
          return {
            ...(typeof p === 'object' ? p : { heading: p }),
            is_requested: !validity.isStillValid,
          };
        });
      }

      // Keep the original file references
      const fileFields = [
        "details_of_machineries",
        "upload_signature",
        "company_seal",
        "lease_agreement",
        "electricity_bill",
        "gst_certificate",
        "pan_certificate",
        "acknowledgement_certificate",
        "unit_registration_certificate",
        "list_of_machines",
        "copy_certificates",
        "ca_certificate",
      ];

      fileFields.forEach((field) => {
        if (renewalData[field]) {
          renewalData[field] = {
            name: renewalData[field].split("/").pop(),
            url: renewalData[field],
          };
        }
      });

      setEditingData(renewalData);
      setIsRenewalMode(true);
      setIsEditing(true);

      // Navigate to Registration section for editing
      setSelectedSection("Registration");
    } else {
      // Cancel renewal mode
      setIsRenewalMode(false);
      setIsEditing(false);
      setEditingData(null);
    }
  };

  const getProductValidityStatus = (productKey) => {
    if (!edccData) return { isStillValid: false };
    
    // Step 1: Check per-product valid_till (future-proofed data)
    let latestValidTill = null;
    
    const checkArray = (arr) => {
      if (!arr) return;
      const prod = arr.find(p => p.heading === productKey);
      if (prod && prod.valid_till) {
        const date = new Date(prod.valid_till);
        if (!latestValidTill || date > latestValidTill) {
          latestValidTill = date;
        }
      }
    };
    
    checkArray(edccData.range_of_products);
    checkArray(edccData.renewed_range_of_products);
    
    // Step 2: Fallback — if no per-product valid_till, use global valid_till
    // for products that are already registered in range_of_products or renewed_range_of_products
    if (!latestValidTill && edccData.valid_till) {
      const isInOriginal = edccData.range_of_products?.some(p => p.heading === productKey);
      const isInRenewed = edccData.renewed_range_of_products?.some(p => p.heading === productKey);
      
      if (isInOriginal || isInRenewed) {
        latestValidTill = new Date(edccData.valid_till);
      }
    }
    
    if (latestValidTill) {
      const now = new Date();
      if (latestValidTill > now) {
        return {
          isStillValid: true,
          validTill: latestValidTill,
          formattedDate: latestValidTill.toLocaleDateString('en-GB')
        };
      }
    }
    
    return { isStillValid: false };
  };

  // Handle product selection in renewal mode
  const handleProductToggle = (productKey) => {
    if (!isEditing || !editingData) return;

    // Check validity before adding in renewal mode
    if (isRenewalMode) {
      const validity = getProductValidityStatus(productKey);
      const targetField = "renewed_range_of_products";
      const selectedProducts = editingData[targetField] || [];
      const isCurrentlySelected = selectedProducts.findIndex(p => p.heading === productKey) >= 0;
      
      // If product is still valid and not currently selected (trying to add), block it
      // If it's already selected and we're trying to remove it, let it pass (or block removal too?)
      // We'll block any toggling of still valid products
      if (validity.isStillValid) {
         return; // Do nothing, product is locked
      }
    }

    const productMapping = {
      "Seating System": { heading: "Seating System", price: 100000 },
      "Office Furniture": { heading: "Office Furniture", price: 150000 },
      "Healthcare Furniture": {
        heading: "Healthcare Furniture",
        price: 100000,
      },
      "Storage Furniture": { heading: "Storage Furniture", price: 100000 },
      "Modular Furniture": { heading: "Modular Furniture", price: 100000 },
      "Classroom Furniture": { heading: "Classroom Furniture", price: 100000 },
      "Institutional Furniture": {
        heading: "Institutional Furniture",
        price: 150000,
      },
      "Classroom and Institutional furniture range": {
        heading: "Classroom and Institutional furniture range",
        price: 250000,
      },
    };

    const targetField = isRenewalMode
      ? "renewed_range_of_products"
      : "range_of_products";
    const selectedProducts = editingData[targetField] || [];
    const productIndex = selectedProducts.findIndex(
      (p) => p.heading === productKey
    );

    if (productIndex >= 0) {
      // Remove product if already selected
      const updatedProducts = selectedProducts.filter(
        (p) => p.heading !== productKey
      );
      setEditingData({
        ...editingData,
        [targetField]: updatedProducts,
      });
    } else {
      // Add product if not selected
      const productToAdd = productMapping[productKey];
      if (productToAdd) {
        setEditingData({
          ...editingData,
          [targetField]: [
            ...selectedProducts,
            { ...productToAdd, sub_items: [], is_new_addition: true, is_requested: true },
          ],
        });
      }
    }
  };

  const addSubItem = (heading) => {
    const input = subItemInputs[heading];
    if (!input || !input.trim()) return;

    const targetField = isRenewalMode
      ? "renewed_range_of_products"
      : "range_of_products";

    setEditingData((prev) => ({
      ...prev,
      [targetField]: prev[targetField].map((p) => {
        if (p && p.heading === heading) {
          return {
            ...p,
            sub_items: [...(p.sub_items || []), input.trim()],
          };
        }
        return p;
      }),
    }));

    setSubItemInputs((prev) => ({
      ...prev,
      [heading]: "",
    }));
  };

  const removeSubItem = (heading, subIdx) => {
    const targetField = isRenewalMode
      ? "renewed_range_of_products"
      : "range_of_products";

    setEditingData((prev) => ({
      ...prev,
      [targetField]: prev[targetField].map((p) => {
        if (p && p.heading === heading) {
          return {
            ...p,
            sub_items: p.sub_items.filter((_, idx) => idx !== subIdx),
          };
        }
        return p;
      }),
    }));
  };

  // Handle input change during editing
  const handleInputChange = (field, value) => {
    const allowedTextFields = ["mobile_number", "contact_office"];
    if (isEditing && editingData) {
      if (!allowedTextFields.includes(field)) return;
      setEditingData({
        ...editingData,
        [field]: value,
      });
    }
  };

  // Helper function to parse document data
  const parseDocumentData = (documentString) => {
    if (!documentString) return null;

    try {
      // If it's already an object, return it
      if (typeof documentString === "object") {
        return documentString;
      }

      // Try to parse as JSON
      const parsed = JSON.parse(documentString);
      return parsed;
    } catch (error) {
      // If parsing fails, treat as plain string (legacy format)
      return {
        name: documentString,
        url: documentString,
      };
    }
  };

  // Handle file change for documents
  const handleFileChange = (field, file) => {
    const editableDocumentFields = [
      "details_of_machineries",
      "upload_signature",
      "company_seal",
      "lease_agreement",
      "electricity_bill",
      "gst_certificate",
      "pan_certificate",
      "acknowledgement_certificate",
      "unit_registration_certificate",
      "list_of_machines",
      "copy_certificates",
      "ca_certificate",
      "affidavit",
      "signed_letter_head",
      "inspection_report",
      "receipt_certificate",
    ];
    if (isEditing && editingData) {
      if (!editableDocumentFields.includes(field)) return;

      // 10MB size validation
      const maxSize = 10 * 1024 * 1024;
      if (file && file.size > maxSize) {
        alert(`${field.replace(/_/g, " ")} size exceeds 10MB. Please upload a smaller file.`);
        return;
      }

      setEditingData({
        ...editingData,
        [field]: file,
      });
    }
  };

  // Validate that all required documents are present before saving
  const validateRequiredDocuments = () => {
    const requiredDocuments = [
      { field: "details_of_machineries", label: "List of Products Manufactured" },
      { field: "lease_agreement", label: "Registry Document/Lease Agreement" },
      { field: "electricity_bill", label: "Electricity Bill" },
      { field: "gst_certificate", label: "GST Registration Certificate" },
      { field: "pan_certificate", label: "PAN Number Registration Certificate" },
      { field: "acknowledgement_certificate", label: "Acknowledgement EM Part-II/Udyog Aadhar" },
      { field: "unit_registration_certificate", label: "Unit Registration Certificate" },
      { field: "ca_certificate", label: "CA Certificate" },
      { field: "copy_certificates", label: "Other Certificates" },
      { field: "list_of_machines", label: "List of Machines" },
      { field: "company_seal", label: "Company Seal" },
      { field: "upload_signature", label: "Upload Signature" },
      { field: "affidavit", label: "Affidavit" },
      { field: "signed_letter_head", label: "Signed Letter Head" },
    ];

    const missingDocuments = requiredDocuments.filter(
      (doc) => !editingData?.[doc.field]
    );

    if (missingDocuments.length > 0) {
      setMissingDocsList(missingDocuments.map((doc) => doc.label));
      setShowMissingDocsModal(true);
      return false;
    }
    return true;
  };

  // Handle save changes with axios
  const handleSaveChanges = async () => {
    try {
      if (!editingData) return;

      // Validate all required documents are present
      if (!validateRequiredDocuments()) return;

      const user =
        JSON.parse(localStorage.getItem("user")) || location.state?.user;
      const token = localStorage.getItem("token") || location.state?.token;

      if (!user || !token) {
        alert("User not authenticated");
        return;
      }

      const updateId = user.details_id || editingData._id;
      const formData = new FormData();

      // Determine which endpoint to use based on mode
      const isRenewal = isRenewalMode;

      // Track changed fields
      const changedFields = [];
      Object.keys(editingData).forEach((key) => {
        const allowedForEdit = [
          "mobile_number",
          "contact_office",
          "details_of_machineries",
          "upload_signature",
          "company_seal",
          "lease_agreement",
          "electricity_bill",
          "gst_certificate",
          "pan_certificate",
          "acknowledgement_certificate",
          "unit_registration_certificate",
          "list_of_machines",
          "copy_certificates",
          "ca_certificate",
          "affidavit",
          "signed_letter_head",
          "inspection_report",
          "receipt_certificate",
          "range_of_products",
          "renewed_range_of_products",
        ];
        const skipOppositeProductField = isRenewal
          ? key === "range_of_products"
          : key === "renewed_range_of_products";
        if (
          allowedForEdit.includes(key) &&
          !skipOppositeProductField &&
          editingData[key] !== edccData[key]
        ) {
          changedFields.push({
            field_name: key,
            old_value: edccData[key],
            new_value: editingData[key],
            edited_at: new Date(),
          });
        }
      });

      // Add changed fields to formData
      formData.append("user_edited_fields", JSON.stringify(changedFields));

      // Handle rejection details - both use is_rejected
      formData.append("is_rejected", false);
      formData.append("rejection_details", "{}");

      // Add is_renewal_requested for renewal submissions
      if (isRenewal) {
        formData.append("is_renewal_requested", "requested");
      }

      // Define fields that should be handled as ObjectIds
      const objectIdFields = [
        "country",
        "state",
        "district",
        "Co_country",
        "Co_state",
        "Co_district",
        "created_by",
        "updated_by",
      ];

      // Add other fields to formData
      Object.entries(editingData).forEach(([key, value]) => {
        // Only allow restricted edits during rejection/renewal edit mode
        const allowedForEdit = [
          "mobile_number",
          "contact_office",
          "details_of_machineries",
          "upload_signature",
          "company_seal",
          "lease_agreement",
          "electricity_bill",
          "gst_certificate",
          "pan_certificate",
          "acknowledgement_certificate",
          "unit_registration_certificate",
          "list_of_machines",
          "copy_certificates",
          "ca_certificate",
          "affidavit",
          "signed_letter_head",
          "inspection_report",
          "receipt_certificate",
          "range_of_products",
          "renewed_range_of_products",
        ];
        const skipFields = ["_id", "email", "Password", "confirm_password"];
        const skipOppositeProductField = isRenewal
          ? key === "range_of_products"
          : key === "renewed_range_of_products";
        if (
          skipFields.includes(key) ||
          !allowedForEdit.includes(key) ||
          skipOppositeProductField
        ) {
          return;
        }

        if (key === "note") {
          // Handle note array properly
          if (Array.isArray(value)) {
            value.forEach((note, index) => {
              formData.append(`note[${index}]`, note);
            });
          }
        } else if (key === "renewed_range_of_products" && isRenewal) {
          // Handle renewed products array for renewal
          if (Array.isArray(value)) {
            formData.append(key, JSON.stringify(value));
          }
        } else if (key === "range_of_products" && !isRenewal) {
          // Handle selected products array for rejected initial registration edits
          if (Array.isArray(value)) {
            formData.append(key, JSON.stringify(value));
          }
        } else if (objectIdFields.includes(key)) {
          // For ObjectId fields, only send if there's a valid value
          if (value && typeof value === "object" && value._id) {
            formData.append(key, value._id);
          } else if (
            typeof value === "string" &&
            value.match(/^[0-9a-fA-F]{24}$/)
          ) {
            formData.append(key, value);
          }
        } else if (value instanceof File) {
          formData.append(key, value);
        } else if (
          typeof value === "object" &&
          value !== null &&
          !Array.isArray(value)
        ) {
          formData.append(key, JSON.stringify(value));
        } else if (value !== null && value !== undefined && value !== "") {
          formData.append(key, value);
        }
      });

      // Log formData contents for debugging
      for (let [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }

      // Use appropriate endpoint based on mode
      const endpoint = isRenewal
        ? `${baseUrl}/edcc/renewal/${updateId}`
        : `${baseUrl}/updateEDCC/${updateId}`;

      const method = isRenewal ? "put" : "put"; // Both use PUT

      const response = await axios[method](endpoint, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.success) {
        // Update local state with new data
        const updatedData = {
          ...response.data.data,
          is_rejected: false,
          rejection_details: {},
        };
        setEdccData(updatedData);
        setIsEditing(false);
        setIsRenewalMode(false);
        setEditingData(null);

        // Reset verification process based on mode
        if (isRenewal) {
          setCurrentStep(1.5); // Renewal verification under process
          setVerificationMessage("Renewal Verification Under Process");
          setVerificationNote(
            "Note: Your renewal application is currently under review. Please wait for verification."
          );
          // Create custom alert div for renewal request submission success
const alertDiv = document.createElement('div');
alertDiv.style.cssText = `
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 30px 40px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.3);
  z-index: 10000;
  max-width: 500px;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

alertDiv.innerHTML = `
  <div style="margin: 0 0 20px 0; color: #28a745; font-size: 48px;">
    ✓
  </div>
  <h3 style="margin: 0 0 15px 0; color: #333; font-size: 22px; font-weight: 600;">
    Renewal Request Submitted Successfully!
  </h3>
  <p style="margin: 0 0 25px 0; color: #666; font-size: 16px; line-height: 1.5;">
    Your application is now under review.
  </p>
  <button onclick="this.parentElement.remove(); document.getElementById('overlay-backdrop').remove();" 
    style="background: #007bff; color: white; border: none; padding: 10px 30px; 
    border-radius: 6px; font-size: 16px; cursor: pointer; font-weight: 500;">
    OK
  </button>
`;

// Create backdrop
const backdrop = document.createElement('div');
backdrop.id = 'overlay-backdrop';
backdrop.style.cssText = `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
`;
backdrop.onclick = () => {
  alertDiv.remove();
  backdrop.remove();
};

document.body.appendChild(backdrop);
document.body.appendChild(alertDiv);
        } else {
          setCurrentStep(1.5); // Set to verification under process
          setVerificationMessage("Verification Under Process");
          setVerificationNote(
            "Note: Your application is currently under review. Please wait for verification."
          );
        // Create custom alert div for details update success
const alertDiv = document.createElement('div');
alertDiv.style.cssText = `
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 30px 40px;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.3);
  z-index: 10000;
  max-width: 500px;
  text-align: center;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

alertDiv.innerHTML = `
  <div style="margin: 0 0 20px 0; color: #28a745; font-size: 48px;">
    ✓
  </div>
  <h3 style="margin: 0 0 15px 0; color: #333; font-size: 22px; font-weight: 600;">
    Details Updated Successfully!
  </h3>
  <p style="margin: 0 0 25px 0; color: #666; font-size: 16px; line-height: 1.5;">
    Your application is now under review.
  </p>
  <button onclick="this.parentElement.remove(); document.getElementById('overlay-backdrop').remove();" 
    style="background: #007bff; color: white; border: none; padding: 10px 30px; 
    border-radius: 6px; font-size: 16px; cursor: pointer; font-weight: 500;">
    OK
  </button>
`;

// Create backdrop
const backdrop = document.createElement('div');
backdrop.id = 'overlay-backdrop';
backdrop.style.cssText = `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  z-index: 9999;
`;
backdrop.onclick = () => {
  alertDiv.remove();
  backdrop.remove();
};

document.body.appendChild(backdrop);
document.body.appendChild(alertDiv);  
        }

        // Redirect to EDCC Login Process page
        setSelectedSection("EDCC Login Process");
      } else {
        alert("Failed to update details. Please try again.");
      }
    } catch (error) {
      console.error("Error updating EDCC data:", error);
      alert(
        `Error updating details: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };
  const parseRejectionNotes = (notes) => {
    if (!notes) return [];

    if (Array.isArray(notes)) {
      return notes.map((note) => {
        if (typeof note === "string") {
          const [section, ...details] = note.split(":");
          return {
            section: section?.trim() || "",
            message: details.join(":").trim(),
          };
        }
        return note;
      });
    }

    if (typeof notes === "string") {
      return notes
        .split(";")
        .map((segment) => segment.trim())
        .filter(Boolean)
        .map((segment) => {
          const [section, ...details] = segment.split(":");
          return {
            section: section?.trim() || "",
            message: details.join(":").trim(),
          };
        });
    }

    return [];
  };

  const formatRejectionNotesSummary = (notes) => {
    const parsedNotes = parseRejectionNotes(notes);
    if (!parsedNotes.length) return "";

    return parsedNotes
      .map((note) => {
        const sectionLabel = note.section ? `${note.section}: ` : "";
        return `${sectionLabel}${note.message || ""}`.trim();
      })
      .filter(Boolean)
      .join(" | ");
  };

  const RejectionMessage = ({ rejectionDetails }) => {
    if (!rejectionDetails) return null;

    let message = "";
    let contactInfo = "";
    const rejectionNotesSummary = formatRejectionNotesSummary(
      rejectionDetails.rejection_notes
    );

    switch (rejectionDetails.rejected_step) {
      case "docVerification":
        message = `Document Verification Rejected: ${rejectionDetails.rejection_reason}`;
        contactInfo = "Please fix the issues and resubmit.";
        break;
      case "PaymentVerification":
        message = `Payment Verification Rejected: ${rejectionDetails.rejection_reason}`;
        contactInfo = "Please contact AIOTA Treasurer for more details.";
        break;
      case "Inspection":
        message = `Inspection Rejected: ${rejectionDetails.rejection_reason}`;
        contactInfo =
          "Please contact AIOTA Admin or President for more details.";
        break;
    }

    return (
      <div
        className="rejection-message"
        style={{ color: "red", marginBottom: "20px" }}
      >
        <div>
          {message}
          {rejectionNotesSummary && (
            <>
              {" "}
              <span style={{ color: "#b02a37" }}>{rejectionNotesSummary}</span>
            </>
          )}
        </div>
        <div>{contactInfo}</div>
      </div>
    );
  };

  // Handle cancel edit
  const handleCancelEdit = () => {
    setIsEditing(false);
    setIsRenewalMode(false);
    setEditingData(null);
  };

  // Check if edit option should be shown (only on rejection)
  const shouldShowEditOption = () => {
    if (!edccData) return false;

    // Only show edit option for document verification rejection
    return (
      edccData.is_rejected === true &&
      edccData.rejection_details?.rejected_step === "docVerification"
    );
  };

  // Check if renewal edit option should be shown (only on renewal rejection)
  const shouldShowRenewalEditOption = () => {
    if (!edccData) return false;

    // Show edit option for renewal document verification rejection
    // Check if it's a renewal and was rejected at docVerification step
    const isRenewal =
      edccData.is_renewal_requested &&
      edccData.is_renewal_requested !== "pending";
    return (
      isRenewal &&
      edccData.is_rejected &&
      edccData.rejection_details?.rejected_step === "docVerification"
    );
  };

  const generatePDF = async (html, filename) => {
    const opt = {
      margin: [0.2, 0, 0, 0],
      filename: filename,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        logging: true,
        imageTimeout: 15000,
      },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };

    try {
      // Add a small delay to ensure images are loaded
      await new Promise((resolve) => setTimeout(resolve, 1000));

      // Generate PDF as blob
      const blob = await html2pdf().from(html).set(opt).outputPdf("blob");

      // Create blob URL for preview
      const blobUrl = URL.createObjectURL(blob);

      // Create download link
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      link.click();
    } catch (error) {
      console.error(`Error generating/downloading ${filename}:`, error);
      alert(`Error generating/downloading ${filename}.`);
    }
  };

  // PDF generation handlers
  const handleGenerateReceiptPDF = async () => {
    try {
      console.log("Starting receipt PDF generation...");
      console.log("EDCC Data:", edccData);

      // Check if the element exists
      const element = document.getElementById("receipt-pdf-content");
      if (!element) {
        console.error("Receipt PDF content element not found");
        alert("PDF content not found. Please refresh the page and try again.");
        return;
      }

      console.log("Receipt PDF content element found:", element);
      console.log("Element content length:", element.innerHTML.length);

      await generateReceiptPDF(edccData);
    } catch (error) {
      console.error("Error generating receipt PDF:", error);
      alert("Error generating PDF. Please try again.");
    }
  };

  const handleOpenReceiptPDF = async () => {
    try {
      console.log("Starting receipt PDF view...");
      console.log("EDCC Data:", edccData);

      // Check if the element exists
      const element = document.getElementById("receipt-pdf-content");
      if (!element) {
        console.error("Receipt PDF content element not found");
        alert("PDF content not found. Please refresh the page and try again.");
        return;
      }

      console.log("Receipt PDF content element found:", element);
      console.log("Element content length:", element.innerHTML.length);

      await openReceiptPDF(edccData);
    } catch (error) {
      console.error("Error opening receipt PDF:", error);
      alert("Error opening PDF. Please try again.");
    }
  };

  const handleGenerateReportPDF = async () => {
    try {
      await generateReportPDF(edccData);
    } catch (error) {
      console.error("Error generating report PDF:", error);
      alert("Error generating PDF. Please try again.");
    }
  };

  const handleOpenReportPDF = async () => {
    try {
      await openReportPDF(edccData);
    } catch (error) {
      console.error("Error opening report PDF:", error);
      alert("Error opening PDF. Please try again.");
    }
  };

  const handleGenerateCertificatePDF = async (product) => {
    try {
      await generateCertificatePDF(edccData, product);
    } catch (error) {
      console.error("Error generating certificate PDF:", error);
      alert("Error generating PDF. Please try again.");
    }
  };

  const handleOpenCertificatePDF = async (product) => {
    try {
      await openCertificatePDF(edccData, product);
    } catch (error) {
      console.error("Error opening certificate PDF:", error);
      alert("Error opening PDF. Please try again.");
    }
  };
  // ...existing code...
  // Utility function to calculate EDCC pricing breakdown with GST
  function calculateEDCCPricingWithGST(products = []) {
    const gstPercentage = 18;

    // Calculate total from products array - keep original prices in rupees
    const productBreakdown = products.map((product) => ({
      name: product.heading,
      price: Math.abs(Number(product.price) || 0), // Ensure positive number
    }));

    const subtotal = productBreakdown.reduce(
      (sum, item) => sum + item.price,
      0
    );
    const gstAmount = Math.round((subtotal * gstPercentage) / 100);
    const totalAmount = subtotal + gstAmount;

    return {
      productBreakdown,
      subtotal,
      gstPercentage,
      gstAmount,
      totalAmount,
    };
  }

  function calculateEDCCRenewalPricingWithGST(products = []) {
    const gstPercentage = 18;
    const renewalFeeByHeading = {
      "Seating System": 150000,
      "Office Furniture": 225000,
      "Classroom Furniture": 150000,
      "Institutional Furniture": 225000,
      "Classroom and Institutional furniture range": 375000,
      "Healthcare Furniture": 150000,
      "Storage Furniture": 150000,
      "Modular Furniture": 150000,
    };

    const productBreakdown = (products || []).map((product) => {
      const heading = product?.heading || "Product";
      const renewalFee =
        renewalFeeByHeading[heading] ??
        Math.abs(Number(product?.price) || 0);
      return { heading, renewalFee };
    });

    const subtotal = productBreakdown.reduce(
      (sum, item) => sum + (Number(item.renewalFee) || 0),
      0
    );
    const gstAmount = Math.round((subtotal * gstPercentage) / 100);
    const totalAmount = subtotal + gstAmount;

    return {
      productBreakdown,
      summary: {
        subtotal,
        gstAmount,
        totalAmount,
      },
      gstPercentage,
    };
  }
  // ...existing code...

  // Check if user is properly authenticated and authorized
  const isUserAuthorized = () => {
    const user =
      JSON.parse(localStorage.getItem("user")) || location.state?.user;
    return user && user.rolename === "EDCC" && user.details_id;
  };

  const isRenewalRequestActive =
    edccData?.is_renewal_requested === "requested";
  const sharedRejectionNotesSummary = formatRejectionNotesSummary(
    edccData?.rejection_details?.rejection_notes
  );

  const nonEditableFieldStyle = isEditing
    ? { backgroundColor: "#f1f3f5", borderColor: "#d9dee3", color: "#6c757d" }
    : {};

  const sections = {
    "EDCC Login Process": () => (
      <div className="profile-content">
        <div className="section-header">
          <h3>EDCC Login Process</h3>
        </div>

        <Row className="progress-container d-flex justify-content-center">
          <div className="progress-steps">
            <div className={`step ${currentStep >= 1 ? "active" : ""}`}>
              <div className="step-number-edcc">1</div>
            </div>
            <div
              className={`step-line ${
                currentStep === 1.5
                  ? "verification-progress"
                  : currentStep >= 2
                  ? "active"
                  : ""
              }`}
            ></div>
            <div className={`step ${currentStep >= 2 ? "active" : ""}`}>
              <div className="step-number-edcc">2</div>
            </div>
            <div
              className={`step-line ${
                currentStep === 2.5
                  ? "verification-progress"
                  : currentStep >= 3
                  ? "active"
                  : ""
              }`}
            ></div>
            <div className={`step ${currentStep >= 3 ? "active" : ""}`}>
              <div className="step-number-edcc">3</div>
            </div>
            <div
              className={`step-line ${
                currentStep === 3.5
                  ? "verification-progress"
                  : currentStep >= 4
                  ? "active"
                  : ""
              }`}
            ></div>
            <div className={`step ${currentStep >= 4 ? "active" : ""}`}>
              <div className="step-number-edcc">4</div>
            </div>
          </div>
        </Row>

        <div className="verification-status">
          <h2>{verificationMessage}</h2>
          {verificationNote && (
            <p className="verification-note">{verificationNote}</p>
          )}

          {/* Payment buttons for step 2 and 2.5 */}
          {(currentStep === 2 || currentStep === 2.5) && (
            <div className="payment-actions">
              <div className="payment-breakdown">
                <h4>Payment Breakdown</h4>
                <div className="pricing-details">
                  {(() => {
                    // Get products based on renewal status
                    const isPaymentForRenewal =
                      edccData?.is_renewal_requested &&
                      edccData.is_renewal_requested !== "pending";
                    const products = isPaymentForRenewal
                      ? edccData?.renewed_range_of_products
                      : edccData?.range_of_products;

                    if (!products || products.length === 0) return null;

                    const pricing = isPaymentForRenewal
                      ? calculateEDCCRenewalPricingWithGST(products)
                      : calculateEDCCPricing(products);
                    return (
                      <>
                        {(isPaymentForRenewal
                          ? edccData?.is_renewed_verified &&
                            !edccData?.is_renewed_payment_done
                          : edccData?.is_verified && !edccData?.is_payment_done) && (
                          <div
                            style={{
                              display: "none",
                              color: "red",
                              fontWeight: 600,
                              marginBottom: "10px",
                            }}
                          >
                            Please pay the payment to the below given bank
                            account details in the notes section and then only
                            click on Proceed button.
                          </div>
                        )}

                        {/* Product Fees */}
                        <div className="product-list-pricing">
                          {isPaymentForRenewal
                            ? pricing.productBreakdown.map((product, index) => (
                                <div key={index} className="product-price-item">
                                  <span className="product-name">
                                    {product.heading}
                                    {product.sub_items && product.sub_items.length > 0 && (
                                      <span> ({product.sub_items.join(", ")})</span>
                                    )}
                                  </span>
                                  <div className="price-breakdown">
                                    <div>
                                      Renewal Fee:{" "}
                                      {formatIndianCurrency(product.renewalFee)}
                                    </div>
                                  </div>
                                </div>
                              ))
                            : pricing.productBreakdown.map((product, index) => (
                                <div key={index} className="product-price-item">
                                  <span className="product-name">
                                    {product.heading}
                                  </span>
                                  <div className="price-breakdown">
                                    <div>
                                      Certification Fee:{" "}
                                      {formatIndianCurrency(product.productFee)}
                                    </div>
                                    <div>
                                      Inspection Fee:{" "}
                                      {formatIndianCurrency(
                                        product.inspectionFee
                                      )}
                                    </div>
                                  </div>
                                </div>
                              ))}
                        </div>

                        {/* Summary */}
                        <div className="pricing-summary" >
                          {isPaymentForRenewal ? (
                            <div className="summary-row">
                              <span>Total Renewal Fees:</span>
                              <span>
                                {formatIndianCurrency(pricing.summary.subtotal)}
                              </span>
                            </div>
                          ) : (
                            <>
                              <div className="summary-row">
                                <span>Total Product Fees:</span>
                                <span>
                                  {formatIndianCurrency(
                                    pricing.summary.productFeesTotal
                                  )}
                                </span>
                              </div>
                              <div className="summary-row">
                                <span>Total Inspection Fees:</span>
                                <span>
                                  {formatIndianCurrency(
                                    pricing.summary.inspectionFeesTotal
                                  )}
                                </span>
                              </div>
                              <div className="summary-row">
                                <span>Registration Fee (incl. GST):</span>
                                <span>
                                  {formatIndianCurrency(
                                    pricing.summary.registrationFee
                                  )}
                                </span>
                              </div>
                            </>
                          )}
                          <div className="summary-row gst-row">
                            <span>GST ({pricing.gstPercentage}%):</span>
                            <span>
                              {formatIndianCurrency(
                                isPaymentForRenewal
                                  ? pricing.summary.gstAmount
                                  : pricing.summary.gstAmount
                              )}
                            </span>
                          </div>
                          <div className="summary-row total-row">
                            <span>Total Amount:</span>
                            <span>
                              {formatIndianCurrency(
                                isPaymentForRenewal
                                  ? pricing.summary.totalAmount
                                  : pricing.summary.totalAmount
                              )}
                            </span>
                          </div>
                        </div>

                        <div className="payment-actions-buttons" style={{ display: "none" }}>
                          <button
                            className="payment-button"
                            onClick={handleProceedToPayment}
                            disabled={
                              loading ||
                              (isPaymentForRenewal
                                ? edccData?.is_renewed_payment_done ||
                                  !edccData?.renewed_range_of_products ||
                                  edccData.renewed_range_of_products.length ===
                                    0
                                : edccData?.is_payment_done ||
                                  !edccData?.range_of_products ||
                                  edccData.range_of_products.length === 0)
                            }
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                Processing...
                              </>
                            ) : (
                              "Proceed"
                            )}
                          </button>
                        </div>

                        <div className="payment-notes">
                          <div className="note warning">
                            <h4>Important Notes:</h4>
                            <ul>
                              {(isPaymentForRenewal
                                ? edccData?.is_renewed_verified &&
                                  !edccData?.is_renewed_payment_done
                                : edccData?.is_verified &&
                                  !edccData?.is_payment_done) && (
                                <li>
                                  Please pay the payment to the below given bank
                                  account details 
                                </li>
                              )}
                              <li>
                                <strong>BANK DETAILS:</strong> Account Name -
                                AIOTA ( All India Occupational Therapists
                                Association) BANK OF BARODA, A/C NO :
                                27410100004459, IFSC : BARB0(zero)SAMART,
                                Branch- Samarth Nagar, Chtrapati Sambhajinagar
                                (Old Aurangabad), Maharashtra.
                              </li>
                              {/* <li>
                                Please pay the above given amount to the given
                                bank account.
                              </li> */}
                              <li>
                                All fees include {pricing.gstPercentage}% GST
                              </li>
                              <li>
                                Registration fee is non-refundable once the
                                certification process begins
                              </li>
                              <li>
                                For any payment-related queries, contact
                                treasurer@aiota.org
                              </li>
                            </ul>
                          </div>
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>
              {isSplitPaymentFlow && (
                <div className="split-payment-progress">
                  <h4>Payment Progress</h4>
                  <div className="progress-indicator">
                    {splitPayments.map((payment, index) => (
                      <div
                        key={index}
                        className={`payment-step ${
                          payment.paid ? "completed" : ""
                        } ${index === currentSplitIndex ? "current" : ""}`}
                      >
                        <div className="step-number-edcc">{index + 1}</div>
                        <div className="step-amount">
                          {formatIndianCurrency(payment.amount)}
                        </div>
                        {payment.paid && (
                          <div className="step-status">✓ Paid</div>
                        )}
                      </div>
                    ))}
                  </div>
                  <p className="progress-text">
                    Completing payment {currentSplitIndex + 1} of{" "}
                    {splitPayments.length}
                  </p>
                </div>
              )}
            </div>
          )}

          {/* No Next button needed for payment steps */}
        </div>

        <Row className="login-process-info">
          <Col className="contact-section-left">
            <div className="contact-label">Contact</div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </div>
              <div className="contact-text">
                <div className="contact-name">Dr. Pankaj Bajpai,</div>
                <div className="contact-title">
                  Executive Chairman, AIOTA Ergonomic
                </div>
                <div className="contact-title">
                  Design Certification, Committee
                </div>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,14.01 9,11.01" />
                </svg>
              </div>
              <div className="contact-text">
                <span>Email: president@aiota.org</span>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
              </div>
              <div className="contact-text">
                <span>Contact Number: +91 94330 98374</span>
              </div>
            </div>
          </Col>

          <Col className="notes-section-right">
            <div className="note-item"></div>

            {/* Add rejection note if exists */}
            {edccData?.is_rejected &&
              edccData?.rejection_details &&
              !isRenewalRequestActive && (
              <div className="note-item warning-item">
                <div className="note-icon-warning">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                    <line x1="12" y1="9" x2="12" y2="13" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                  </svg>
                </div>
                <p style={{ color: "red" }}>
                  {edccData.rejection_details.rejected_step ===
                    "docVerification" && (
                    <>
                      Document Verification Rejected:{" "}
                      {[
                        
                        sharedRejectionNotesSummary
                      ]
                        .filter(Boolean)
                        .join(" ")}
                      <br />
                      Please fix the issues and resubmit.
                    </>
                  )}
                  {edccData.rejection_details.rejected_step ===
                    "PaymentVerification" && (
                    <>
                    
                      {[
           
                        sharedRejectionNotesSummary,
                      ]
                        .filter(Boolean)
                        .join(" ")}
                      <br />
                      Please contact AIOTA Treasurer for more details.
                    </>
                  )}
                  {edccData.rejection_details.rejected_step ===
                    "Inspection" && (
                    <>
                
                      {[
                      
                        sharedRejectionNotesSummary
                      ]
                        .filter(Boolean)
                        .join(" ")}
                      <br />
                      Please contact AIOTA Secretary or President for more
                      details.
                    </>
                  )}
                </p>
              </div>
            )}

            {/* Renewal rejection note */}
            {isRenewalRequestActive && edccData?.is_rejected && (
                <div className="note-item warning-item">
                  <div className="note-icon-warning">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                      <line x1="12" y1="9" x2="12" y2="13" />
                      <line x1="12" y1="17" x2="12.01" y2="17" />
                    </svg>
                  </div>
                  <p style={{ color: "red" }}>
                    Renewal Rejected:{" "}
                    {[
                      edccData.rejection_reason ||
                      sharedRejectionNotesSummary,
                    ]
                      .filter(Boolean)
                      .join(" ") || "Please fix the highlighted issues."}
                    <br />
                    Please fix the issues and resubmit.in case of  issues of payment or inspection rejection please contact AIOTA Admin.
                  </p>
                </div>
              )}

            <div className="note-item warning-item">
              <div className="note-icon-warning">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                  <line x1="12" y1="9" x2="12" y2="13" />
                  <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
              </div>
              <p>
                Note: No other means of communication (such as WhatsApp, calls,
                or instant messages) will not be entertained.
              </p>
            </div>
            {/* Edit button for rejection case - positioned below notes */}
            {shouldShowEditOption() && (
              <div
                className="edit-actions"
                style={{ marginTop: "20px", width: "100%" }}
              >
                <button
                  className={`edit-button ${isEditing ? "save-button" : ""}`}
                  onClick={isEditing ? handleSaveChanges : handleEditToggle}
                >
                  {isEditing ? "Save Changes" : "Edit Details"}
                </button>
                {isEditing && (
                  <button className="cancel-button" onClick={handleCancelEdit}>
                    Cancel
                  </button>
                )}
              </div>
            )}
            {/* Renewal edit button for renewal rejection case */}
            {shouldShowRenewalEditOption() && (
              <div
                className="edit-actions"
                style={{ marginTop: "20px", width: "100%" }}
              >
                {/* <button
                  className={`edit-button ${
                    isRenewalMode && isEditing ? "save-button" : ""
                  }`}
                  onClick={
                    isRenewalMode && isEditing
                      ? handleSaveChanges
                      : handleRenewalToggle
                  }
                >
                  {isRenewalMode && isEditing
                    ? "Submit Renewal"
                    : "Start Renewal"}
                </button> */}
                {isRenewalMode && isEditing && (
                  <button className="cancel-button" onClick={handleCancelEdit}>
                    Cancel
                  </button>
                )}
              </div>
            )}
          </Col>
        </Row>
      </div>
    ),

    Registration: () => (
      <div className="profile-content">
        <div className="section-header">
          <h3>Organization Information</h3>
        </div>

        {loading ? (
          <div className="loading-message">Loading registration details...</div>
        ) : error ? (
          <div className="error-message">{error}</div>
        ) : edccData ? (
          <div className="accordion-container">
            <div
              className={`accordion ${
                activeAccordion === "orgInfo" ? "active" : ""
              }`}
              ref={(el) => (sectionRefs.current[0] = el)}
            >
              <div
                className="accordion-header"
                onClick={() => toggleAccordion("orgInfo", 0)}
              >
                <span>Organization Info</span>
                <span className="accordion-icon">
                  {activeAccordion === "orgInfo" ? (
                    <ChevronUp
                      className="accordion-arrow"
                      size={18}
                      strokeWidth={2}
                    />
                  ) : (
                    <ChevronDown
                      className="accordion-arrow"
                      size={18}
                      strokeWidth={2}
                    />
                  )}
                </span>
              </div>
              {activeAccordion === "orgInfo" && (
                <div className="accordion-content">
                  <Row className="">
                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>Name of organization or Agency:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.name_of_organization || ""
                            : edccData?.name_of_organization || "N/A"
                        }
                        readOnly={true}
                        style={nonEditableFieldStyle}
                      />
                    </Col>
                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>Legal Status of Firm/Unit/Company:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.legal_status || ""
                            : edccData?.legal_status || "N/A"
                        }
                        readOnly={true}
                        style={nonEditableFieldStyle}
                      />
                    </Col>
                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>PAN Number:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.pan_number || ""
                            : edccData?.pan_number || "N/A"
                        }
                        readOnly={true}
                        style={nonEditableFieldStyle}
                        onChange={(e) =>
                          handleInputChange("pan_number", e.target.value)
                        }
                      />
                    </Col>

                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>Contact person with Office Position:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.contact_office || ""
                            : edccData?.contact_office || "N/A"
                        }
                        readOnly={!isEditing}
                        className={isEditing ? "editable" : ""}
                        onChange={(e) =>
                          handleInputChange("contact_office", e.target.value)
                        }
                      />
                    </Col>
                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>Year of Establishment:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.year_of_establishment || ""
                            : edccData?.year_of_establishment
                            ? new Date(
                                edccData.year_of_establishment
                              ).getFullYear() // ✅ extract only year
                            : "N/A"
                        }
                        readOnly={true}
                        style={nonEditableFieldStyle}
                        onChange={(e) =>
                          handleInputChange(
                            "year_of_establishment",
                            e.target.value
                          )
                        }
                      />
                    </Col>

                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>Company Web Site:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.website_url || ""
                            : edccData?.website_url || "N/A"
                        }
                        readOnly={true}
                        style={nonEditableFieldStyle}
                        onChange={(e) =>
                          handleInputChange("website_url", e.target.value)
                        }
                      />
                    </Col>

                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>Name on Certificate:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.name_certificate || ""
                            : edccData?.name_certificate || "N/A"
                        }
                        readOnly={true}
                        style={nonEditableFieldStyle}
                        onChange={(e) =>
                          handleInputChange("name_certificate", e.target.value)
                        }
                      />
                    </Col>
                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>E-mail Address:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.email || ""
                            : edccData?.email || "N/A"
                        }
                        readOnly={true}
                        style={nonEditableFieldStyle}
                      />
                    </Col>
                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>Name of Proprietor/Partners/Directors:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.name_of_partner || ""
                            : edccData?.name_of_partner || "N/A"
                        }
                        readOnly={true}
                        style={nonEditableFieldStyle}
                        onChange={(e) =>
                          handleInputChange("name_of_partner", e.target.value)
                        }
                      />
                    </Col>

                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>GST Registration Number:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.gst_number || ""
                            : edccData?.gst_number || "N/A"
                        }
                        readOnly={true}
                        style={nonEditableFieldStyle}
                        onChange={(e) =>
                          handleInputChange("gst_number", e.target.value)
                        }
                      />
                    </Col>
                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>Address on Certificate:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.certificate_address || ""
                            : edccData?.certificate_address || "N/A"
                        }
                        readOnly={true}
                        style={nonEditableFieldStyle}
                      />
                    </Col>
                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>Mobile Number:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.mobile_number || ""
                            : edccData?.mobile_number || "N/A"
                        }
                        readOnly={!isEditing}
                        className={isEditing ? "editable" : ""}
                        onChange={(e) =>
                          handleInputChange("mobile_number", e.target.value)
                        }
                      />
                    </Col>
                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>Toll Free Number:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.toll_free_number || ""
                            : edccData?.toll_free_number || "N/A"
                        }
                        readOnly={true}
                        style={nonEditableFieldStyle}
                        onChange={(e) =>
                          handleInputChange("toll_free_number", e.target.value)
                        }
                      />
                    </Col>

                  </Row>
                </div>
              )}
            </div>

            <div
              className={`accordion ${
                activeAccordion === "contactInfo" ? "active" : ""
              }`}
              ref={(el) => (sectionRefs.current[1] = el)}
            >
              <div
                className="accordion-header"
                onClick={() => toggleAccordion("contactInfo", 1)}
              >
                <span>Contact Information</span>
                <span className="accordion-icon">
                  {activeAccordion === "contactInfo" ? (
                    <ChevronUp
                      className="accordion-arrow"
                      size={18}
                      strokeWidth={2}
                    />
                  ) : (
                    <ChevronDown
                      className="accordion-arrow"
                      size={18}
                      strokeWidth={2}
                    />
                  )}
                </span>
              </div>
              {activeAccordion === "contactInfo" && (
                <div
                  className={`accordion-content ${
                    isEditing ? "edcc-locked-section" : ""
                  }`}
                  style={
                    isEditing
                      ? {
                          pointerEvents: "none",
                          opacity: 0.75,
                          userSelect: "none",
                        }
                      : {}
                  }
                >
                  <div className="address-section">
                    <h4>Office / Correspondence Address :</h4>

                    <Row className="">
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={6}
                        xl={4}
                      >
                        <label>Flat/House NO/ Floor/ Building :</label>
                        <input
                          type="text"
                          value={
                            isEditing
                              ? editingData?.flat_house_building || ""
                              : edccData?.flat_house_building || "N/A"
                          }
                          readOnly={!isEditing}
                          className={isEditing ? "editable" : ""}
                          onChange={(e) =>
                            handleInputChange(
                              "flat_house_building",
                              e.target.value
                            )
                          }
                        />
                      </Col>
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={6}
                        xl={4}
                      >
                        <label>Colony/Street/Locality :</label>
                        <input
                          type="text"
                          value={
                            isEditing
                              ? editingData?.colony_street_locality || ""
                              : edccData?.colony_street_locality || "N/A"
                          }
                          readOnly={!isEditing}
                          className={isEditing ? "editable" : ""}
                          onChange={(e) =>
                            handleInputChange(
                              "colony_street_locality",
                              e.target.value
                            )
                          }
                        />
                      </Col>
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={12}
                        xl={4}
                      >
                        <label>Landmark :</label>
                        <input
                          type="text"
                          value={
                            isEditing
                              ? editingData?.landmark || ""
                              : edccData?.landmark || "N/A"
                          }
                          readOnly={!isEditing}
                          className={isEditing ? "editable" : ""}
                          onChange={(e) =>
                            handleInputChange("landmark", e.target.value)
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="">
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={6}
                        xl={3}
                      >
                        <label>Country :</label>
                        {isEditing ? (
                          <select
                            value={getEntityId(editingData?.country)}
                            className="editable"
                            onChange={(e) =>
                              handleCountrySelection(e.target.value)
                            }
                          >
                            <option value="">Select Country</option>
                            {countryOptions.map((country) => (
                              <option key={country._id} value={country._id}>
                                {country.country_name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={edccData?.country?.country_name || "N/A"}
                            readOnly
                          />
                        )}
                      </Col>
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={6}
                        xl={3}
                      >
                        <label>State :</label>
                        {isEditing ? (
                          <select
                            value={getEntityId(editingData?.state)}
                            className="editable"
                            onChange={(e) =>
                              handleStateSelection(e.target.value)
                            }
                          >
                            <option value="">Select State</option>
                            {stateOptions.map((state) => (
                              <option key={state._id} value={state._id}>
                                {state.state_name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={edccData?.state?.state_name || "N/A"}
                            readOnly
                          />
                        )}
                      </Col>
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={6}
                        xl={3}
                      >
                        <label>District :</label>
                        {isEditing ? (
                          <select
                            value={getEntityId(editingData?.district)}
                            className="editable"
                            onChange={(e) =>
                              handleDistrictSelection(e.target.value)
                            }
                          >
                            <option value="">Select District</option>
                            {districtOptions.map((district) => (
                              <option key={district._id} value={district._id}>
                                {district.district_name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={edccData?.district?.district_name || "N/A"}
                            readOnly
                          />
                        )}
                      </Col>
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={6}
                        xl={3}
                      >
                        <label>Pincode :</label>
                        <input
                          type="text"
                          value={
                            isEditing
                              ? editingData?.pincode || ""
                              : edccData?.pincode || "N/A"
                          }
                          readOnly={!isEditing}
                          className={isEditing ? "editable" : ""}
                          onChange={(e) =>
                            handleInputChange("pincode", e.target.value)
                          }
                        />
                      </Col>
                    </Row>
                  </div>

                  <div className="address-section">
                    <h4>Factory Address :</h4>

                    <Row className="">
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={6}
                        xl={4}
                      >
                        <label>Flat/House NO/ Floor/ Building :</label>
                        <input
                          type="text"
                          value={
                            isEditing
                              ? editingData?.co_flat_house_building || ""
                              : edccData?.co_flat_house_building || "N/A"
                          }
                          readOnly={!isEditing}
                          className={isEditing ? "editable" : ""}
                          onChange={(e) =>
                            handleInputChange(
                              "co_flat_house_building",
                              e.target.value
                            )
                          }
                        />
                      </Col>
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={6}
                        xl={4}
                      >
                        <label>Colony/Street/Locality :</label>
                        <input
                          type="text"
                          value={
                            isEditing
                              ? editingData?.Co_colony_street_locality || ""
                              : edccData?.Co_colony_street_locality || "N/A"
                          }
                          readOnly={!isEditing}
                          className={isEditing ? "editable" : ""}
                          onChange={(e) =>
                            handleInputChange(
                              "Co_colony_street_locality",
                              e.target.value
                            )
                          }
                        />
                      </Col>
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={12}
                        xl={4}
                      >
                        <label>Landmark :</label>
                        <input
                          type="text"
                          value={
                            isEditing
                              ? editingData?.co_landmark || ""
                              : edccData?.co_landmark || "N/A"
                          }
                          readOnly={!isEditing}
                          className={isEditing ? "editable" : ""}
                          onChange={(e) =>
                            handleInputChange("co_landmark", e.target.value)
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="">
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={6}
                        xl={3}
                      >
                        <label>Country :</label>
                        {isEditing ? (
                          <select
                            value={getEntityId(editingData?.Co_country)}
                            className="editable"
                            onChange={(e) =>
                              handleFactoryCountrySelection(e.target.value)
                            }
                          >
                            <option value="">Select Country</option>
                            {countryOptions.map((country) => (
                              <option key={country._id} value={country._id}>
                                {country.country_name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={edccData?.Co_country?.country_name || "N/A"}
                            readOnly
                          />
                        )}
                      </Col>
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={6}
                        xl={3}
                      >
                        <label>State :</label>
                        {isEditing ? (
                          <select
                            value={getEntityId(editingData?.Co_state)}
                            className="editable"
                            onChange={(e) =>
                              handleFactoryStateSelection(e.target.value)
                            }
                          >
                            <option value="">Select State</option>
                            {factoryStateOptions.map((state) => (
                              <option key={state._id} value={state._id}>
                                {state.state_name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={edccData?.Co_state?.state_name || "N/A"}
                            readOnly
                          />
                        )}
                      </Col>
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={6}
                        xl={3}
                      >
                        <label>District :</label>
                        {isEditing ? (
                          <select
                            value={getEntityId(editingData?.Co_district)}
                            className="editable"
                            onChange={(e) =>
                              handleFactoryDistrictSelection(e.target.value)
                            }
                          >
                            <option value="">Select District</option>
                            {factoryDistrictOptions.map((district) => (
                              <option key={district._id} value={district._id}>
                                {district.district_name}
                              </option>
                            ))}
                          </select>
                        ) : (
                          <input
                            type="text"
                            value={
                              edccData?.Co_district?.district_name || "N/A"
                            }
                            readOnly
                          />
                        )}
                      </Col>
                      <Col
                        className="field-group"
                        sm={12}
                        md={12}
                        lg={6}
                        xl={3}
                      >
                        <label>Pincode :</label>
                        <input
                          type="text"
                          value={
                            isEditing
                              ? editingData?.Co_pincode || ""
                              : edccData?.Co_pincode || "N/A"
                          }
                          readOnly={!isEditing}
                          className={isEditing ? "editable" : ""}
                          onChange={(e) =>
                            handleInputChange("Co_pincode", e.target.value)
                          }
                        />
                      </Col>
                    </Row>
                          <Row className="mb-4">
                      <Col className="field-group" sm={12} md={6} lg={6} xl={6}>
                        <label>
                          Address to be printed on certificate :
                        </label>
                        <input
                          type="text"
                          value={
                            isEditing
                              ? editingData?.address_to_be_printed_on_certificate ||
                                ""
                              : edccData?.address_to_be_printed_on_certificate ||
                                "N/A"
                          }
                          readOnly={!isEditing}
                          className={isEditing ? "editable" : ""}
                          onChange={(e) =>
                            handleInputChange(
                              "address_to_be_printed_on_certificate",
                              e.target.value
                            )
                          }
                        />
                      </Col>
                  </Row>
                  </div>
                </div>
              )}
            </div>

            <div
              className={`accordion ${
                activeAccordion === "productsInfo" ? "active" : ""
              }`}
              ref={(el) => (sectionRefs.current[2] = el)}
            >
              <div
                className="accordion-header"
                onClick={() => toggleAccordion("productsInfo", 2)}
              >
                <span>Range of Products</span>
                <span className="accordion-icon">
                  {activeAccordion === "productsInfo" ? (
                    <ChevronUp
                      className="accordion-arrow"
                      size={18}
                      strokeWidth={2}
                    />
                  ) : (
                    <ChevronDown
                      className="accordion-arrow"
                      size={18}
                      strokeWidth={2}
                    />
                  )}
                </span>
              </div>
              {activeAccordion === "productsInfo" && (
                <div className="accordion-content">
                  <div className="product-list">
                    <h4>Range of Products {isRenewalMode ? "For Renewal" : ""}</h4>
                    {isEditing ? (
                      // Edit mode (initial rejection/renewal): show selected + pending products
                      <>
                        {(() => {
                          const allProducts = [
                            { heading: "Seating System", price: 100000 },
                            { heading: "Office Furniture", price: 150000 },
                            { heading: "Healthcare Furniture", price: 100000 },
                            { heading: "Storage Furniture", price: 100000 },
                            { heading: "Modular Furniture", price: 100000 },
                            { heading: "Classroom Furniture", price: 100000 },
                            {
                              heading: "Institutional Furniture",
                              price: 150000,
                            },
                            {
                              heading: "Classroom and Institutional furniture range",
                              price: 250000,
                            },
                          ];
                          const targetField = isRenewalMode
                            ? "renewed_range_of_products"
                            : "range_of_products";
                          const selectedProducts =
                            editingData?.[targetField] || [];
                          const selectedHeadings = selectedProducts.map(
                            (p) => p.heading
                          );

                          // In renewal mode, filter out still-valid products completely
                          const availableProducts = isRenewalMode
                            ? allProducts.filter((product) => {
                                const validity = getProductValidityStatus(product.heading);
                                return !validity.isStillValid; // Only show expired or brand new
                              })
                            : allProducts;

                          // Gather still-valid products for info display in renewal mode
                          const validProducts = isRenewalMode
                            ? allProducts.filter((product) => {
                                const validity = getProductValidityStatus(product.heading);
                                return validity.isStillValid;
                              })
                            : [];

                          return (
                            <>
                              {/* Show info about still-valid products in renewal mode */}
                              {isRenewalMode && validProducts.length > 0 && (
                                <div style={{ 
                                  marginBottom: "16px", 
                                  padding: "12px", 
                                  backgroundColor: "#f0f9ff", 
                                  borderLeft: "4px solid #2196F3",
                                  borderRadius: "4px" 
                                }}>
                                  <p style={{ margin: "0 0 8px 0", fontWeight: "600", color: "#1565C0" }}>
                                    Already Registered (Still Valid)
                                  </p>
                                  {validProducts.map((product, idx) => {
                                    const validity = getProductValidityStatus(product.heading);
                                    // Find sub_items from DB data
                                    const dbProduct = 
                                      edccData?.renewed_range_of_products?.find(p => p.heading === product.heading) ||
                                      edccData?.range_of_products?.find(p => p.heading === product.heading);
                                    return (
                                      <div key={`valid_${idx}`} style={{ 
                                        padding: "6px 0", 
                                        color: "#333",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "8px"
                                      }}>
                                        <span style={{ color: "#4CAF50", fontWeight: "bold" }}>✓</span>
                                        <span>{product.heading}</span>
                                        {dbProduct?.sub_items?.length > 0 && (
                                          <span style={{ color: "#888", fontSize: "0.9em" }}>
                                            ({dbProduct.sub_items.join(", ")})
                                          </span>
                                        )}
                                        <span style={{ 
                                          marginLeft: "auto", 
                                          color: "#d9534f", 
                                          fontSize: "0.85em", 
                                          fontWeight: "bold" 
                                        }}>
                                          Valid till {validity.formattedDate}
                                        </span>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}

                              {/* Show available products (expired + new) */}
                              {isRenewalMode && (
                                <p style={{ marginBottom: "10px", color: "#666" }}>
                                  Select products to renew or add new ones:
                                </p>
                              )}
                              {!isRenewalMode && (
                                <p style={{ marginBottom: "10px", color: "#666" }}>
                                  Select your products:
                                </p>
                              )}

                              {availableProducts.length > 0 ? (
                                availableProducts.map((product, index) => {
                                  const isSelected = selectedHeadings.includes(product.heading);
                                  const selectedProductData = selectedProducts.find(p => p.heading === product.heading);

                                  return (
                                    <div
                                      className="product-item"
                                      key={`product_${index}`}
                                    >
                                      <div className="product-checkbox-label">
                                        <input
                                          type="checkbox"
                                          id={`product_${index}`}
                                          checked={isSelected}
                                          onChange={() =>
                                            handleProductToggle(product.heading)
                                          }
                                        />
                                        <label htmlFor={`product_${index}`}>
                                          {product.heading}
                                        </label>
                                      </div>

                                      {/* Dynamic sub-items */}
                                      {isSelected && (
                                        <div className="seating-sub-items-container">
                                          <div className="sub-item-input-group">
                                            <input
                                              type="text"
                                              value={
                                                subItemInputs[product.heading] || ""
                                              }
                                              onChange={(e) =>
                                                setSubItemInputs((prev) => ({
                                                  ...prev,
                                                  [product.heading]: e.target.value,
                                                }))
                                              }
                                              placeholder={`Enter ${product.heading.toLowerCase()} details...`}
                                              className="sub-item-input"
                                            />
                                            <button
                                              type="button"
                                              onClick={() =>
                                                addSubItem(product.heading)
                                              }
                                              className="add-sub-item-btn"
                                            >
                                              Add
                                            </button>
                                          </div>
                                          <ul className="sub-items-list">
                                            {(selectedProductData?.sub_items || []).map(
                                              (sub, subIdx) => (
                                                <li
                                                  key={subIdx}
                                                  className="sub-item-chip"
                                                >
                                                  {sub}
                                                  <button
                                                    type="button"
                                                    onClick={() =>
                                                      removeSubItem(
                                                        product.heading,
                                                        subIdx
                                                      )
                                                    }
                                                    className="remove-sub-item-btn"
                                                  >
                                                    ×
                                                  </button>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                        </div>
                                      )}
                                    </div>
                                  );
                                })
                              ) : (
                                <p className="text-muted small">
                                  {isRenewalMode 
                                    ? "All products are currently valid. No products available for renewal at this time."
                                    : "No products available"}
                                </p>
                              )}
                            </>
                          );
                        })()}
                      </>
                    ) : (
                      // View mode - show current products or renewed products if renewal certificates are issued
                      (() => {
                        // If renewal certificates are issued, show renewed products, otherwise show original products
                        const productsToShow =
                          edccData?.is_renewed_certificates_issued
                            ? edccData.renewed_range_of_products
                            : edccData.range_of_products;

                        return productsToShow && productsToShow.length > 0 ? (
                          productsToShow.map((product, index) => (
                            <div className="product-item" key={index}>
                              <input
                                type="checkbox"
                                id={`product_${index}`}
                                checked
                                readOnly
                              />
                              <label htmlFor={`product_${index}`}>
                                {product.heading}
                                {product.sub_items && product.sub_items.length > 0 && (
                                  <span> ({product.sub_items.join(", ")})</span>
                                )}
                              </label>
                            </div>
                          ))
                        ) : (
                          <p>No products selected</p>
                        );
                      })()
                    )}
                  </div>
                </div>
              )}
            </div>

            <div
              className={`accordion ${
                activeAccordion === "manufacturingInfo" ? "active" : ""
              }`}
              ref={(el) => (sectionRefs.current[3] = el)}
            >
              <div
                className="accordion-header"
                onClick={() => toggleAccordion("manufacturingInfo", 3)}
              >
                <span>Manufacturing Facilities</span>
                <span className="accordion-icon">
                  {activeAccordion === "manufacturingInfo" ? (
                    <ChevronUp
                      className="accordion-arrow"
                      size={18}
                      strokeWidth={2}
                    />
                  ) : (
                    <ChevronDown
                      className="accordion-arrow"
                      size={18}
                      strokeWidth={2}
                    />
                  )}
                </span>
              </div>
              {activeAccordion === "manufacturingInfo" && (
                <div
                  className={`accordion-content ${
                    isEditing ? "edcc-locked-section" : ""
                  }`}
                  style={
                    isEditing
                      ? {
                          pointerEvents: "none",
                          opacity: 0.75,
                          userSelect: "none",
                        }
                      : {}
                  }
                >
                  <h4>Area of Factory</h4>

                  <Row className="">
                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>Total Plot / Land Area (Sq. Ft):</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.plot || ""
                            : edccData?.plot || "N/A"
                        }
                        readOnly={!isEditing}
                        className={isEditing ? "editable" : ""}
                        onChange={(e) =>
                          handleInputChange("plot", e.target.value)
                        }
                      />
                    </Col>
                    <Col className="field-group" sm={12} md={12} lg={6} xl={4}>
                      <label>Total Covered Area:Sq.Ft:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.total_area || ""
                            : edccData?.total_area || "N/A"
                        }
                        readOnly={!isEditing}
                        className={isEditing ? "editable" : ""}
                        onChange={(e) =>
                          handleInputChange("total_area", e.target.value)
                        }
                      />
                    </Col>
                    <Col className="field-group" sm={12} md={12} lg={12} xl={4}>
                      <label>Administrative Area:Sq.Ft</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.administartive_area || ""
                            : edccData?.administartive_area || "N/A"
                        }
                        readOnly={!isEditing}
                        className={isEditing ? "editable" : ""}
                        onChange={(e) =>
                          handleInputChange(
                            "administartive_area",
                            e.target.value
                          )
                        }
                      />
                    </Col>
                  </Row>

                  <Row className="">
                    <Col
                      className="field-group full-width"
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                    >
                      <label>Production Shed:Sq.Ft</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.production_shed || ""
                            : edccData?.production_shed || "N/A"
                        }
                        readOnly={!isEditing}
                        className={isEditing ? "editable" : ""}
                        onChange={(e) =>
                          handleInputChange("production_shed", e.target.value)
                        }
                      />
                    </Col>
                  </Row>
                  <h4>Electric Power</h4>
                  <Row className="">
                    <Col className="field-group" sm={12} md={12} lg={6} xl={6}>
                      <label>Domestic/Commercial/Industrial:</label>
                      {isEditing ? (
                        <select
                          value={(
                            editingData?.domestic_commercial || ""
                          ).toLowerCase()}
                          className="editable"
                          onChange={(e) =>
                            handleInputChange(
                              "domestic_commercial",
                              e.target.value
                            )
                          }
                        >
                          <option value="">Select Power Type</option>
                          <option value="domestic">Domestic</option>
                          <option value="commercial">Commercial</option>
                          <option value="industrial">Industrial</option>
                        </select>
                      ) : (
                        <input
                          type="text"
                          value={edccData?.domestic_commercial || "N/A"}
                          readOnly
                        />
                      )}
                    </Col>
                    <Col className="field-group" sm={12} md={12} lg={6} xl={6}>
                      <label>Sanctioned Power Load</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.power_load || ""
                            : edccData?.power_load || "N/A"
                        }
                        readOnly={!isEditing}
                        className={isEditing ? "editable" : ""}
                        onChange={(e) =>
                          handleInputChange("power_load", e.target.value)
                        }
                      />
                    </Col>
                  </Row>

                  <h4>
                    Manufacturing Registration Certificate Certificate Issued
                    As:
                  </h4>
             {isEditing ? (
  <div className="certificate-issued-options">
    {["Micro/Small", "Medium/Large"].map((size) => (
      <label key={size} className="certificate-issued-option">
        <input
          type="radio"
          name="certificate_issued_edit"
          value={size}
          checked={(editingData?.certificate_issued || "") === size}
          onChange={() =>
            handleInputChange("certificate_issued", size)
          }
        />
        {size}
      </label>
    ))}
  </div>
) : (
  <p>{edccData?.certificate_issued || "N/A"}</p>
)}


                  <Row className="">
                    <Col className="field-group" sm={12} md={12} lg={12} xl={6}>
                      <label>Available Certificates:</label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.available_certificate || ""
                            : edccData?.available_certificate || "N/A"
                        }
                        readOnly={!isEditing}
                        className={isEditing ? "editable" : ""}
                        onChange={(e) =>
                          handleInputChange(
                            "available_certificate",
                            e.target.value
                          )
                        }
                      />
                    </Col>
                    <Col className="field-group" sm={12} md={12} lg={12} xl={6}>
                      <label>
                        The Annual Turnover for Manufacturing Furniture:
                      </label>
                      <input
                        type="text"
                        value={
                          isEditing
                            ? editingData?.annual_turnover || ""
                            : edccData?.annual_turnover || "N/A"
                        }
                        readOnly={!isEditing}
                        className={isEditing ? "editable" : ""}
                        onChange={(e) =>
                          handleInputChange("annual_turnover", e.target.value)
                        }
                      />
                    </Col>
                  </Row>
                </div>
              )}
            </div>

            <div
              className={`accordion ${
                activeAccordion === "documentsInfo" ? "active" : ""
              }`}
              ref={(el) => (sectionRefs.current[4] = el)}
            >
              <div
                className="accordion-header"
                onClick={() => toggleAccordion("documentsInfo", 4)}
              >
                <span>Uploaded Documents</span>
                <span className="accordion-icon">
                  {activeAccordion === "documentsInfo" ? (
                    <ChevronUp
                      className="accordion-arrow"
                      size={18}
                      strokeWidth={2}
                    />
                  ) : (
                    <ChevronDown
                      className="accordion-arrow"
                      size={18}
                      strokeWidth={2}
                    />
                  )}
                </span>
              </div>
              {activeAccordion === "documentsInfo" && (
                <div className="accordion-content">
                  <Row className="documents-list">
                    {/* List of products manufactured (letterhead with seal & signature) */}

                    <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>
                        List of products manufactured (letterhead with seal &
                        signature)
                      </span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.details_of_machineries
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "details_of_machineries",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="details_of_machineries_upload"
                            />
                            <label
                              htmlFor="details_of_machineries_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.details_of_machineries ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.details_of_machineries.name ||
                                    editingData.details_of_machineries}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange(
                                      "details_of_machineries",
                                      null
                                    );
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Registry document/Lease Agreement */}
                    <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>
                        Registry document/Lease Agreement (verifying total area &
                        covered area)
                      </span>
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "lease_agreement",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="lease_agreement_upload"
                            />
                            <label
                              htmlFor="lease_agreement_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.lease_agreement ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.lease_agreement.name ||
                                    editingData.lease_agreement}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange("lease_agreement", null);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>
                        Copy of latest/last three-month electricity bill in the
                        name of the manufacturing plant of the firm
                      </span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.electricity_bill
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "electricity_bill",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="electricity_bill_upload"
                            />
                            <label
                              htmlFor="electricity_bill_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.electricity_bill ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.electricity_bill.name ||
                                    editingData.electricity_bill}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange("electricity_bill", null);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>Copy of GST Registration Certificate</span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.gst_certificate
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "gst_certificate",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="gst_certificate_upload"
                            />
                            <label
                              htmlFor="gst_certificate_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.gst_certificate ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.gst_certificate.name ||
                                    editingData.gst_certificate}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange("gst_certificate", null);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>Copy of PAN Number Registration certificate</span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.pan_certificate
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "pan_certificate",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="pan_certificate_upload"
                            />
                            <label
                              htmlFor="pan_certificate_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.pan_certificate ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.pan_certificate.name ||
                                    editingData.pan_certificate}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange("pan_certificate", null);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>
                        Copy of Acknowledgement EM Part-II/Udyog Aadhar
                        Memorandum issued by the Industries Department in case
                        of Micro/Small Units
                      </span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.acknowledgement_certificate
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "acknowledgement_certificate",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="acknowledgement_certificate_upload"
                            />
                            <label
                              htmlFor="acknowledgement_certificate_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.acknowledgement_certificate ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.acknowledgement_certificate
                                    .name ||
                                    editingData.acknowledgement_certificate}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange(
                                      "acknowledgement_certificate",
                                      null
                                    );
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>Copy of Unit Registration Certificate</span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.unit_registration_certificate
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "unit_registration_certificate",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="unit_registration_certificate_upload"
                            />
                            <label
                              htmlFor="unit_registration_certificate_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.unit_registration_certificate ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.unit_registration_certificate
                                    .name ||
                                    editingData.unit_registration_certificate}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange(
                                      "unit_registration_certificate",
                                      null
                                    );
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>Copy of CA Certificate</span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.ca_certificate
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "ca_certificate",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="ca_certificate_upload"
                            />
                            <label
                              htmlFor="ca_certificate_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.ca_certificate ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.ca_certificate.name ||
                                    editingData.ca_certificate}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange("ca_certificate", null);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>Copy of Other Certificates</span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.copy_certificates
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "copy_certificates",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="copy_certificates_upload"
                            />
                            <label
                              htmlFor="copy_certificates_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.copy_certificates ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.copy_certificates.name ||
                                    editingData.copy_certificates}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange("copy_certificates", null);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>List of Machines</span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.list_of_machines
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "list_of_machines",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="list_of_machines_upload"
                            />
                            <label
                              htmlFor="list_of_machines_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.list_of_machines ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.list_of_machines.name ||
                                    editingData.list_of_machines}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange("list_of_machines", null);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>Company Seal</span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.company_seal
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "company_seal",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="company_seal_upload"
                            />
                            <label
                              htmlFor="company_seal_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.company_seal ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.company_seal.name ||
                                    editingData.company_seal}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange("company_seal", null);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>Upload Signature</span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.upload_signature
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "upload_signature",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="upload_signature_upload"
                            />
                            <label
                              htmlFor="upload_signature_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.upload_signature ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.upload_signature.name ||
                                    editingData.upload_signature}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange("upload_signature", null);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
 <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>Affidavit</span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.affidavit
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "affidavit",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="affidavit_upload"
                            />
                            <label
                              htmlFor="affidavit_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.affidavit ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.affidavit.name ||
                                    editingData.affidavit}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange("affidavit", null);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                     <div className="document-item">
                      <svg className="pdf-icon" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z M10,10V12H8V10H10M16,15V12H12V15H16M16,19V17H12V19H16M16,11V10H14V11H16M10,14V15H8V14H10M10,19V17H8V19H10M10,12V11H8V12H10Z"
                        />
                      </svg>
                      <span>Signed Letter Head</span>
                      {(() => {
                        const docData = parseDocumentData(
                          edccData?.signed_letter_head
                        );
                        // return docData && !isEditing ? (
                        //   <div className="current-document">
                        //     <span className="current-file">
                        //       Current: {docData.name}
                        //     </span>
                        //   </div>
                        // ) : null;
                      })()}
                      {isEditing && (
                        <div className="document-edit">
                          <div className="file-upload-wrapper">
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                              onChange={(e) => {
                                if (e.target.files[0]) {
                                  handleFileChange(
                                    "signed_letter_head",
                                    e.target.files[0]
                                  );
                                }
                              }}
                              id="signed_letter_head_upload"
                            />
                            <label
                              htmlFor="signed_letter_head_upload"
                              className="file-upload-label"
                            >
                              Choose File
                            </label>
                          </div>
                          <div className="file-info">
                            {editingData?.signed_letter_head ? (
                              <div className="selected-file">
                                <span className="file-name">
                                  Selected:{" "}
                                  {editingData.signed_letter_head.name ||
                                    editingData.signed_letter_head}
                                </span>
                                <button
                                  className="remove-file"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileChange("signed_letter_head", null);
                                  }}
                                >
                                  Remove
                                </button>
                              </div>
                            ) : (
                              <span className="no-file">No file selected</span>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    {/* Note field - display only, not editable */}
                    {/* {edccData?.note && ( */}
                      {/* <div className="document-item note-item"> */}
                        {/* <svg className="pdf-icon" viewBox="0 0 24 24">
                          <path
                            fill="currentColor"
                            d="M14,2H6A2,2 0,0,0 4,4V20A2,2 0,0,0 6,22H18A2,2 0,0,0 20,20V8L14,2M6V4H13V9H18V20H6V4Z"
                          />
                        </svg> */}
                        {/* <span>Important Notes</span>
                        <div className="note-content">
                          {Array.isArray(edccData.note) ? (
                            edccData.note.map((noteItem, index) => (
                              <p key={index} className="note-text">
                                {noteItem}
                              </p>
                            ))
                          ) : (
                            <p className="note-text">{edccData.note}</p>
                          )}
                        </div>
                      </div>
                    )} */}
                  </Row>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="no-data-message">
            <h4>Welcome! Your registration is being processed.</h4>
            <p>
              Your EDCC registration form has been submitted successfully. The
              verification process will begin shortly.
            </p>
            <p>
              You can view your registration details here once the verification
              is complete.
            </p>
          </div>
        )}

        {/* Renewal submission message */}
        {!isEditing &&
          edccData?.is_renewal_requested &&
          edccData.is_renewal_requested !== "pending" &&
          !edccData?.is_renewed_certificates_issued && (
            <div
              className="renewal-submission-message"
              style={{
                marginTop: "20px",
                padding: "15px",
                backgroundColor: "#fff3cd",
                border: "1px solid #ffc107",
                borderRadius: "8px",
                color: "#856404",
              }}
            >
              <p style={{ margin: 0, fontWeight: "bold" }}>
                ✓ Your renewal documents have been submitted and are waiting for
                renewal verification.
              </p>
            </div>
          )}

        {/* Submit Renewal button for renewal mode */}
        {isRenewalMode && isEditing && (
          <div className="edit-actions" style={{ marginTop: "20px" }}>
            <Button className="save-button w-auto" onClick={handleSaveChanges}>
              Submit Renewal
            </Button>
            <button className="cancel-button" onClick={handleCancelEdit}>
              Cancel
            </button>
          </div>
        )}

        {/* Edit button at bottom of card */}
        {shouldShowEditOption() && (
          <div className="edit-actions">
            <button
              className={`edit-button ${isEditing ? "save-button" : ""}`}
              onClick={isEditing ? handleSaveChanges : handleEditToggle}
            >
              {isEditing ? "Save Changes" : "Edit Details"}
            </button>
            {isEditing && (
              <button className="cancel-button" onClick={handleCancelEdit}>
                Cancel
              </button>
            )}
          </div>
        )}
      </div>
    ),

    Receipts: () => (
      <div className="profile-content">
        <div className="section-header">
          <h3>Payment Receipt</h3>
        </div>

        {(() => {
          const renewedReceiptsRaw =
            edccData?.renewedEdccReceipts ||
            edccData?.renewed_edcc_receipts ||
            edccData?.renewed_edcc_receipt ||
            [];
          const renewedReceipts = Array.isArray(renewedReceiptsRaw)
            ? renewedReceiptsRaw
            : renewedReceiptsRaw
            ? [renewedReceiptsRaw]
            : [];

          const hasAnyReceipt =
            renewedReceipts.length > 0 || !!edccData?.receipt_certificate;

          const isImageUrl = (url) => {
            if (!url) return false;
            return (
              url.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp|webp)$/) !==
                null ||
              url.toLowerCase().includes("/image/") ||
              url.toLowerCase().includes("image/")
            );
          };

          return hasAnyReceipt ? (
            <>
              {/* Renewal receipt (latest only, show at top if present) */}
              {renewedReceipts.length > 0 && (() => {
                const getUrl = (r) =>
                  typeof r === "string" ? r : r?.receipt_url || r?.url || r?.file_url;
                const getTime = (r) => {
                  const t =
                    r?.uploaded_at ||
                    r?.created_at ||
                    r?.createdAt ||
                    r?.updated_at ||
                    r?.updatedAt ||
                    r?.date ||
                    r?.issued_at;
                  const ms = t ? new Date(t).getTime() : NaN;
                  return Number.isNaN(ms) ? 0 : ms;
                };
                const latest = [...renewedReceipts].sort((a, b) => {
                  const tA = getTime(a);
                  const tB = getTime(b);
                  if (tA === 0 && tB === 0) {
                    // No timestamps: treat last added as latest
                    return renewedReceipts.indexOf(b) - renewedReceipts.indexOf(a);
                  }
                  return tB - tA;
                })[0];
                const url = getUrl(latest);
                if (!url) return null;

                return (
                  <>
                    {/* <h5 className="mb-4 fw-bold text-primary">Renewal Receipt</h5> */}
                    <Row className="mb-5">
                      <Col md={12} className="mb-3">
                        <Form.Group>
                          <Form.Label className="fw-bold mb-3">
                            Renewal Payment Invoice / Receipt
                          </Form.Label>
                          <div className="border border-2 rounded p-3 shadow-sm bg-white">
                            {isImageUrl(url) ? (
                              <div className="text-center">
                                <img
                                  src={url}
                                  alt="Latest renewal receipt"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "500px",
                                    objectFit: "contain",
                                    borderRadius: "8px",
                                  }}
                                  className="border"
                                />
                              </div>
                            ) : (
                              <embed
                                src={url}
                                type="application/pdf"
                                width="100%"
                                height="700px"
                                style={{ borderRadius: "8px", border: "none" }}
                              />
                            )}

                            <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                              <span className="text-muted fw-500">
                                <FileText
                                  size={18}
                                  className="me-2 text-primary"
                                />
                                EDCC Renewal Receipt — {edccData.name_of_organization}
                              </span>

                              <Button
                                variant="success"
                                onClick={() =>
                                  handleDownloadFile(
                                    url,
                                    `EDCC_Renewal_Receipt_${edccData.name_of_organization.replace(
                                      /\s+/g,
                                      "_"
                                    )}.pdf`
                                  )
                                }
                              >
                                <Download size={18} className="me-2" />
                                Download Receipt
                              </Button>
                            </div>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                );
              })()}

              {/* Original receipt */}
              {edccData?.receipt_certificate && (
                <Row className="mb-4">
                  <Col md={12} className="mb-3">
                    <Form.Group>
                      <Form.Label className="fw-bold mb-3">
                        Payment Invoice / Receipt
                      </Form.Label>
                      <div className="border border-2 rounded p-3 shadow-sm bg-white">
                        <embed
                          src={edccData.receipt_certificate}
                          type="application/pdf"
                          width="100%"
                          height="700px"
                          style={{ borderRadius: "8px", border: "none" }}
                        />

                        <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                          <span className="text-muted fw-500">
                            <FileText size={18} className="me-2 text-danger" />
                            AIOTA EDCC Payment Receipt — {edccData.name_of_organization}
                          </span>

                          <Button
                            variant="success"
                            onClick={() =>
                              handleDownloadFile(
                                edccData.receipt_certificate,
                                `EDCC_Receipt_${edccData.name_of_organization.replace(
                                  /\s+/g,
                                  "_"
                                )}_${new Date().getFullYear()}.pdf`
                              )
                            }
                          >
                            <Download size={18} className="me-2" />
                            Download Receipt
                          </Button>
                        </div>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              )}
            </>
          ) : (
            <div className="text-center py-5 my-5">
              <FileText size={64} className="text-muted mb-4 opacity-50" />
              <h5 className="text-muted">No Receipt Available Yet</h5>
              <p className="text-muted col-lg-6 mx-auto">
                The payment receipt will appear here automatically once your
                payment is successfully verified by the treasurer.
              </p>
            </div>
          );
        })()}

        {edccData?.receipt_certificate && (
          <Alert variant="success" className="mt-4">
            <i className="fas fa-check-circle me-2"></i>
            <strong>Payment Verified</strong> — Receipt issued on{" "}
            {new Date(
              edccData.payment_verified_at || edccData.payment_date
            ).toLocaleDateString("en-IN")}
          </Alert>
        )}
      </div>
    ),
Reports: () => (
  <div className="profile-content">
    <div className="section-header">
      <h3>Inspection Reports</h3>
    </div>

    {/* Helper function to check if URL is an image */}
    {(() => {
      const isImageUrl = (url) => {
        if (!url) return false;
        return url.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp|webp)$/) !== null ||
               url.toLowerCase().includes('/image/') ||
               url.toLowerCase().includes('image/');
      };

      // Helper function for downloading files (images or PDFs)
      const handleFileDownload = async (fileUrl, defaultFileName) => {
        if (!fileUrl) return;
        
        let fileName = edccData?.name_of_organization || defaultFileName;
        fileName = fileName.replace(/[^a-zA-Z0-9]/g, '') || defaultFileName;
        
        try {
          const response = await fetch(fileUrl, { mode: "cors" });
          const blob = await response.blob();
          const blobUrl = window.URL.createObjectURL(blob);
          
          const extension = blob.type.includes("png") ? ".png" : 
                           blob.type.includes("jpeg") ? ".jpg" : 
                           blob.type.includes("gif") ? ".gif" : 
                           blob.type.includes("webp") ? ".webp" : 
                           blob.type.includes("pdf") ? ".pdf" : "";
          
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = `${fileName}${extension}`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
          console.error("Download failed:", error);
          window.open(fileUrl, "_blank");
        }
      };

      return (
        <>
          {/* Display latest Renewal Inspection Report if available */}
          {edccData?.renewal_inspection_report &&
            edccData.renewal_inspection_report.length > 0 &&
            (() => {
              const getTime = (r) => {
                const t =
                  r?.uploaded_at ||
                  r?.created_at ||
                  r?.createdAt ||
                  r?.updated_at ||
                  r?.updatedAt ||
                  r?.inspection_date;
                const ms = t ? new Date(t).getTime() : NaN;
                return Number.isNaN(ms) ? 0 : ms;
              };
              const latestReport = [...edccData.renewal_inspection_report].sort(
                (a, b) => getTime(b) - getTime(a)
              )[0];
              if (!latestReport?.report_url) return null;

              return (
                <Row className="mb-4">
                  <Col md={12} className="mb-4">
                    <Form.Group>
                      <Form.Label className="fw-bold mb-3">
                        Latest Renewal Inspection Report
                      </Form.Label>
                      <div className="border border-2 rounded p-3 shadow-sm bg-white">
                        {isImageUrl(latestReport.report_url) ? (
                          <div className="text-center">
                            <img
                              src={latestReport.report_url}
                              alt="Latest Renewal EDCC Inspection Report"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "500px",
                                objectFit: "contain",
                                borderRadius: "8px",
                              }}
                              className="border"
                            />
                          </div>
                        ) : (
                          <embed
                            src={latestReport.report_url}
                            type="application/pdf"
                            width="100%"
                            height="700px"
                            style={{ borderRadius: "8px" }}
                          />
                        )}

                        <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                          <span className="text-muted fw-500">
                            <FileText size={18} className="me-2 text-info" />
                            Renewal EDCC Inspection Report —{" "}
                            {edccData.name_of_organization}
                            {isImageUrl(latestReport.report_url) && (
                              <span className="ms-2 badge bg-info">Image</span>
                            )}
                            <div className="small text-muted mt-1">
                              Uploaded:{" "}
                              {new Date(
                                latestReport.uploaded_at ||
                                  latestReport.created_at ||
                                  latestReport.createdAt ||
                                  latestReport.updated_at ||
                                  latestReport.updatedAt ||
                                  new Date()
                              ).toLocaleDateString("en-IN")}
                            </div>
                          </span>

                          <Button
                            variant="primary"
                            style={{ width: "auto", minWidth: "fit-content" }}
                            onClick={() =>
                              handleFileDownload(
                                latestReport.report_url,
                                "Renewal_EDCC_Inspection_Report"
                              )
                            }
                          >
                            <Download size={18} className="me-2" />
                            Download Report
                          </Button>
                        </div>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              );
            })()}

          {/* Original Inspection Report */}
          {edccData?.inspection_report ? (
            <Row className="mb-4">
              <Col md={12}>
                <Form.Group>
                  <Form.Label className="fw-bold mb-3">
                    Original Inspection Report
                  </Form.Label>
                  <div className="border border-2 rounded p-3 shadow-sm bg-white">
                    {isImageUrl(edccData.inspection_report) ? (
                      // For images: display as image tag
                      <div className="text-center">
                        <img 
                          src={edccData.inspection_report} 
                          alt="Original EDCC Inspection Report"
                          style={{ 
                            maxWidth: '100%', 
                            maxHeight: '500px', 
                            objectFit: 'contain',
                            borderRadius: '8px'
                          }} 
                          className="border"
                        />
                      </div>
                    ) : (
                      // For PDFs: use embed tag
                      <embed
                        src={edccData.inspection_report}
                        type="application/pdf"
                        width="100%"
                        height="700px"
                        style={{ borderRadius: "8px" }}
                      />
                    )}

                    <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                      <span className="text-muted fw-500">
                        <FileText size={18} className="me-2 text-primary" />
                        Original EDCC Inspection Report — {edccData.name_of_organization}
                        {isImageUrl(edccData.inspection_report) && (
                          <span className="ms-2 badge bg-info">Image</span>
                        )}
                      </span>

                      <Button
                        variant="primary"
                        style={{ width: "auto", minWidth: "fit-content" }}
                        onClick={() => handleFileDownload(
                          edccData.inspection_report, 
                          "Original_EDCC_Inspection_Report"
                        )}
                      >
                        <Download size={18} className="me-2" />
                        Download Report
                      </Button>
                    </div>
                  </div>
                </Form.Group>
              </Col>
            </Row>
          ) : (
            !edccData?.renewal_inspection_report?.length > 0 && (
              <div className="text-center py-5 my-5">
                <FileSearch size={64} className="text-muted mb-4 opacity-50" />
                <h5 className="text-muted">Inspection Report Not Available</h5>
                <p className="text-muted col-lg-6 mx-auto">
                  The official inspection report will be uploaded here after the
                  physical inspection is completed and approved.
                </p>
              </div>
            )
          )}

          {edccData?.inspection_report && (
            <Alert variant="info">
              <i className="fas fa-calendar-check me-2"></i>
              Original inspection completed on{" "}
              {new Date(
                edccData.inspection_date || edccData.inspection_verified_at
              ).toLocaleDateString("en-IN")}
            </Alert>
          )}
        </>
      );
    })()}
  </div>
),

    Certificates: () => {
      const activeRenewedCerts = (
        edccData?.renewedEdccCertificates ||
        edccData?.renewed_edcc_certificates ||
        edccData?.renewed_edccCertificates ||
        []
      ).filter((cert) => !cert?.isDeleted);

      const activeEdccCerts = (edccData?.edccCertificates || []).filter(
        (cert) => !cert?.isDeleted
      );

      return (
      <div className="profile-content">
        <div className="section-header">
          <h3>EDCC Certificates</h3>
        </div>

        {/* Current Valid (Renewal) Certificates */}
        {activeRenewedCerts.length > 0 && (
          <>
            <h5 className="mb-4 fw-bold text-primary">
              Current Valid Certificates
            </h5>

            <Row className="g-4 mb-5">
              {activeRenewedCerts.map((cert, index) => {
        if (!cert) return null;
        const displayName =
          (cert?.certificate_name || "").trim() || `Certificate ${index + 1}`;

        return (
          <Col xs={12} md={6} lg={4} key={index}>
            <Card className="h-100 shadow border-0 certificate-card">
              <Card.Body className="text-center p-4">
                <h5 className="fw-bold text-dark">{displayName}</h5>

                <small className="text-success d-block">
                  Issued on{" "}
                  {cert?.issued_at
                    ? new Date(cert.issued_at).toLocaleDateString("en-IN")
                    : "N/A"}
                </small>

                <div className="d-grid gap-2 mt-4">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="w-100"
                    onClick={() => window.open(cert.certificate_url, "_blank")}
                  >
                    View
                  </Button>

                  <Button
                    variant="primary"
                    size="sm"
                    className="w-100"
                    onClick={() => {
                      const safeName = (displayName || "EDCC_Certificate").replace(
                        /\s+/g,
                        "_"
                      );
                      handleDownloadFile(
                        cert.certificate_url,
                        `EDCC_Certificate_${safeName}_${edccData.name_of_organization.replace(
                          /\s+/g,
                          "_"
                        )}.pdf`
                      );
                    }}
                  >
                    <Download size={18} className="me-2" />
                    Download
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        );
                })}
              </Row>
            </>
        )}

        {activeEdccCerts.length > 0 && (
          <>
            <h5 className="mb-4 fw-bold text-success mt-5">
              Certificates History
            </h5>

            <Row className="g-4">
              {activeEdccCerts.map((cert, i) => {
        const displayName =
          (cert?.certificate_name || "").trim() || `Certificate ${i + 1}`;

        return (
          <Col xs={12} md={6} lg={4} key={i}>
            <Card className="h-100 shadow-sm border-success">
              <Card.Body className="text-center p-4">
                <h6 className="fw-bold">{displayName}</h6>

                <small className="text-success d-block">
                  Issued on{" "}
                  {new Date(cert.issued_at).toLocaleDateString("en-IN")}
                </small>

                <div className="d-grid gap-2 mt-3">
                  <Button
                    variant="outline-success"
                    size="sm"
                    onClick={() =>
                      window.open(cert.certificate_url, "_blank")
                    }
                  >
                    View
                  </Button>

                  <Button
                    variant="success"
                    size="sm"
                    onClick={() =>
                      handleDownloadFile(
                        cert.certificate_url,
                        `EDCC_Old_${displayName.replace(
                          /\s+/g,
                          "_"
                        )}_${new Date(cert.issued_at).getFullYear()}.pdf`
                      )
                    }
                  >
                    Download
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        );
              })}
            </Row>
          </>
        )}

        {/* No certificates yet */}
        {activeEdccCerts.length === 0 && activeRenewedCerts.length === 0 && (
          <div className="text-center py-5 my-5">
            <Award size={64} className="text-muted mb-4 opacity-50" />
            <h5 className="text-muted">Certificates Not Issued Yet</h5>
            <p className="text-muted col-lg-6 mx-auto">
              Your official EDCC certificate(s) will appear here automatically
              once the inspection is complete and certificate is issued by the
              committee.
            </p>
          </div>
        )}
      </div>
      );
    },

    Renewal: () => (
      <div className="profile-content">
        <div className="section-header">
          <h3>EDCC Renewal</h3>
        </div>
        {loading ? (
          <div className="loading-message">Loading Renewal details...</div>
        ) : (
          <>
            {/* First Row - 3 fields */}
            <div className="renewal-row d-flex flex-column flex-xxl-row">
              {/* <div className="renewal-field">
            <h4>EDCC ID:</h4>
            <div className="renewal-value">
              AIOTA/EDCC/
              {new Date(edccData?.inspection_date || new Date()).getFullYear()}/
              {edccData?.details_id || "N/A"}
            </div>
          </div> */}
              {/* <div className="renewal-field">
                <h4>Company Name:</h4>
                <div className="renewal-value">
                  {edccData?.name_of_organization || "N/A"}
                </div>
              </div>
              <div className="renewal-field">
                <h4>Certificate Issued Date:</h4>
                <div className="renewal-value">
                  {finalCertificateIssuedDate
                    ? finalCertificateIssuedDate.toLocaleDateString("en-US", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                      })
                    : "N/A"}
                </div>
              </div> */}
            </div>

            {/* Second Row - 1 field */}
            {/* <div className="renewal-row">
              <div className="renewal-field">
                <h4>Certificate Expiry Date:</h4>
                <div className="renewal-value">
                  {calculatedValidityDate
                    ? calculatedValidityDate.toLocaleDateString("en-US", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                        timeZone: "Asia/Kolkata",
                      })
                    : "N/A"}
                </div>
              </div>
            </div> */}


            {/* Guidelines Section */}
            {/* <div className="renewal-section">
          <h4>Guidelines</h4>
          <div className="renewal-guidelines">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat.
            </p>
            <p>
              Duis aute irure dolor in reprehenderit in voluptate velit esse
              cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
              cupidatat non proident, sunt in culpa qui officia deserunt mollit
              anim id est laborum.
            </p>
          </div>
        </div> */}

            {/* Centered Renew Button - show if renewal_requested is pending, approved, or not set */}
            {(!edccData?.is_renewal_requested ||
              edccData.is_renewal_requested === "pending" ||
              edccData.is_renewal_requested === "approved") && (
              <>
                <div className="renewal-consent-section" style={{ marginTop: '30px', marginBottom: '20px', padding: '20px', backgroundColor: '#fff8e1', border: '1px solid #ffe082', borderRadius: '8px', color: '#5d4037', fontSize: '0.95em' }}>
                  <h4 style={{ marginTop: 0, color: '#d84315', display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <span style={{ fontSize: '1.2em' }}>⚠</span> Important Note Before Proceeding with Renewal
                  </h4>
                  <p style={{ marginBottom: '10px' }}>Please read the following carefully before continuing:</p>
                  <p style={{ marginBottom: '5px' }}>This renewal section can be used for:</p>
                  <ul style={{ marginBottom: '15px', paddingLeft: '20px' }}>
                    <li>Renewal of your existing product categories, and/or</li>
                    <li>Applying for new product categories</li>
                  </ul>
                  
                  <div style={{ marginBottom: '15px' }}>
                    <p style={{ margin: 0 }}><strong>If you are renewing existing product categories:</strong></p>
                    <p style={{ margin: 0 }}>Please select only your existing approved product categories in the "Range of Products" section and continue with the renewal process.</p>
                  </div>
                  
                  <div style={{ marginBottom: '15px' }}>
                    <p style={{ margin: 0 }}><strong>If you want to apply for a new product category:</strong></p>
                    <p style={{ margin: 0 }}>Please use the "Add New Category" option in the Product Section and proceed accordingly.</p>
                  </div>
                  
                  <div style={{ backgroundColor: '#ffccbc', padding: '12px', borderRadius: '6px', border: '1px solid #ffab91', marginTop: '15px' }}>
                    <p style={{ margin: 0, fontWeight: 'bold', color: '#bf360c', marginBottom: '5px' }}>⚠ Important:</p>
                    <ul style={{ margin: 0, paddingLeft: '20px', color: '#bf360c' }}>
                      <li>If you are applying for renewal, do not select new categories in the renewal section and vice versa.</li>
                      <li>If you are applying for a new category, please add it only through the "Add New Category" option.</li>
                      <li>Please ensure the correct option is selected before submission.</li>
                    </ul>
                  </div>
                  
                  <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: '20px', padding: '10px', backgroundColor: '#ffffff', borderRadius: '4px', border: '1px solid #e0e0e0' }}>
                    <input 
                      type="checkbox" 
                      id="renewalConsent" 
                      checked={renewalConsentChecked} 
                      onChange={(e) => setRenewalConsentChecked(e.target.checked)}
                      style={{ marginTop: '4px', marginRight: '10px', width: '18px', height: '18px', cursor: 'pointer', flexShrink: 0 }}
                    />
                    <label htmlFor="renewalConsent" style={{ cursor: 'pointer', margin: 0, fontWeight: 'bold', userSelect: 'none' }}>
                      I have read and understood the instructions above.
                    </label>
                  </div>
                </div>

                <div className="renewal-button-container">
                  <Button
                    className="renewal-button"
                    onClick={handleRenewalToggle}
                    disabled={!renewalConsentChecked}
                    style={{ opacity: renewalConsentChecked ? 1 : 0.6, cursor: renewalConsentChecked ? 'pointer' : 'not-allowed' }}
                  >
                    RENEW NOW
                  </Button>
                </div>
              </>
            )}

            {/* Show message only if renewal is requested (but not approved) */}
            {edccData?.is_renewal_requested === "requested" && (
              <div className="renewal-status-message">
                <p>Renewal Application Submitted</p>
                <p>Your renewal application is being processed.</p>
              </div>
            )}
          </>
        )}
      </div>
    ),
    "Change Password": () => (
      <div className="profile-content-change-password">
        <div className="section-header">
          <h3>Change Password</h3>
        </div>
        <div className="change-password-section">
          <Container className="">
            <h2 className="text-center mb-4 pt-4">Change Password</h2>
            {passwordError && (
              <Alert variant="danger" className="mt-3">
                {passwordError}
              </Alert>
            )}
            {passwordSuccess && (
              <Alert variant="success" className="mt-3">
                {passwordSuccess}
              </Alert>
            )}
            <Row className="justify-content-center">
              <Col lg={6}>
                <Form onSubmit={handlePasswordSubmit}>
                  <Form.Group controlId="currentPassword" className="mb-3">
                    <Form.Label className="form-label-change-password">
                      Current Password *
                    </Form.Label>
                    <Form.Control
                      type="password"
                      name="currentPassword"
                      className="form-control-change-password"
                      value={passwordData.currentPassword}
                      onChange={(e) =>
                        setPasswordData((prev) => ({
                          ...prev,
                          currentPassword: e.target.value,
                        }))
                      }
                      placeholder="Enter current password"
                      required
                      disabled={passwordLoading}
                    />
                  </Form.Group>
                  <Form.Group controlId="newPassword" className="mb-3">
                    <Form.Label className="form-label-change-password">
                      New Password *
                    </Form.Label>
                    <Form.Control
                      type="password"
                      name="newPassword"
                      className="form-control-change-password"
                      value={passwordData.newPassword}
                      onChange={(e) =>
                        setPasswordData((prev) => ({
                          ...prev,
                          newPassword: e.target.value,
                        }))
                      }
                      placeholder="Enter new password"
                      required
                      disabled={passwordLoading}
                    />
                  </Form.Group>
                  <Form.Group controlId="confirmPassword" className="mb-4">
                    <Form.Label className="form-label-change-password">
                      Confirm New Password *
                    </Form.Label>
                    <Form.Control
                      type="password"
                      name="confirmPassword"
                      className="form-control-change-password"
                      value={passwordData.confirmPassword}
                      onChange={(e) =>
                        setPasswordData((prev) => ({
                          ...prev,
                          confirmPassword: e.target.value,
                        }))
                      }
                      placeholder="Confirm new password"
                      required
                      disabled={passwordLoading}
                    />
                  </Form.Group>
                  <Row className="d-flex gap-2 justify-content-center">
                    <Button
                      variant="primary"
                      type="submit"
                      className="change-password-button"
                      disabled={passwordLoading}
                    >
                      {passwordLoading ? "Changing..." : "Change Password"}
                    </Button>
                    <Button
                      variant="secondary"
                      onClick={() => {
                        setPasswordData({
                          currentPassword: "",
                          newPassword: "",
                          confirmPassword: "",
                        });
                        setPasswordError("");
                        setPasswordSuccess("");
                        setSelectedSection("EDCC Login Process");
                      }}
                      className="w-auto"
                      disabled={passwordLoading}
                    >
                      Cancel
                    </Button>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    ),
    // Add other sections (Reports, Certificates, Renewal) as needed
  };

  if (isLoggingOut) {
    return null;
  }

  // Show error if user is not authorized
  if (!isUserAuthorized()) {
    return (
      <div className="profile-page">
        <section className="hero-fixed">
          <div className="hero-content">
            <h1>Ergonomic Design Certificate Login</h1>
          </div>
        </section>
        <div className="scrollable-content">
          <div className="content-container">
            <div className="error-message">
              <h3>Access Denied</h3>
              <p>
                You are not authorized to access the EDCC profile. Please ensure
                you are logged in with an EDCC account.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-page">
      {/* Fixed Hero Section */}
      <section
        className="hero-fixed"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <div className="hero-scroll-content">
          <div className="hero-content-home poppins-regular">
            <h1 className="hero-heading">
              All India Occupational Therapists' Association
            </h1>
          </div>
        </div>
      </section>

      {/* Scrollable Content Container */}
      <div className="scrollable-content-home">
        <div className="content-container">
          <div className="sidebar-container">
            <div className="sidebar">
              <ul>
                <li
                  className={
                    selectedSection === "EDCC Login Process" ? "active" : ""
                  }
                  onClick={() => handleSectionClick("EDCC Login Process")}
                >
                  EDCC Login Process
                </li>
                <li
                  className={`${
                    selectedSection === "Registration" ? "active" : ""
                  } ${!isSectionClickable("Registration") ? "blurred" : ""}`}
                  onClick={() => handleSectionClick("Registration")}
                  style={{
                    cursor: isSectionClickable("Registration")
                      ? "pointer"
                      : "not-allowed",
                  }}
                >
                  {isRenewalMode ? "Renewal" : ""} Registration
                </li>
                <li
                  className={`${
                    selectedSection === "Receipts" ? "active" : ""
                  } ${!isSectionClickable("Receipts") ? "blurred" : ""}`}
                  onClick={() => handleSectionClick("Receipts")}
                  style={{
                    cursor: isSectionClickable("Receipts")
                      ? "pointer"
                      : "not-allowed",
                  }}
                  title={
                    !isSectionClickable("Receipts")
                      ? "Complete verification process first"
                      : ""
                  }
                >
                  Receipts
                </li>
                <li
                  className={`${
                    selectedSection === "Reports" ? "active" : ""
                  } ${!isSectionClickable("Reports") ? "blurred" : ""}`}
                  onClick={() => handleSectionClick("Reports")}
                  style={{
                    cursor: isSectionClickable("Reports")
                      ? "pointer"
                      : "not-allowed",
                  }}
                  title={
                    !isSectionClickable("Reports")
                      ? "Complete inspection process first"
                      : ""
                  }
                >
                  Reports
                </li>
                <li
                  className={`${
                    selectedSection === "Certificates" ? "active" : ""
                  } ${!isSectionClickable("Certificates") ? "blurred" : ""}`}
                  onClick={() => handleSectionClick("Certificates")}
                  style={{
                    cursor: isSectionClickable("Certificates")
                      ? "pointer"
                      : "not-allowed",
                  }}
                  title={
                    !isSectionClickable("Certificates")
                      ? "Complete all previous steps first"
                      : ""
                  }
                >
                  Certificates
                </li>
                <li
                  className={`${
                    selectedSection === "Renewal" ? "active" : ""
                  } ${!isSectionClickable("Renewal") ? "blurred" : ""}`}
                  onClick={() => handleSectionClick("Renewal")}
                  style={{
                    cursor: isSectionClickable("Renewal")
                      ? "pointer"
                      : "not-allowed",
                  }}
                  title={
                    !isSectionClickable("Renewal")
                      ? "Complete certification process first"
                      : ""
                  }
                >
                  New/Renewal
                </li>
                <li
                  className={`${
                    selectedSection === "Change Password" ? "active" : ""
                  } ${!isSectionClickable("Change Password") ? "blurred" : ""}`}
                  onClick={() => handleSectionClick("Change Password")}
                  style={{
                    cursor: isSectionClickable("Change Password")
                      ? "pointer"
                      : "not-allowed",
                  }}
                  title={
                    !isSectionClickable("Change Password")
                      ? "Complete registration process first"
                      : ""
                  }
                >
                  Change Password
                </li>
                <li
                  className="sign-out"
                  onClick={handleSignOut}
                  style={{ cursor: "pointer" }}
                >
                  Sign Out
                </li>
              </ul>
            </div>
            <div className="main-content">
              <div className="profile-details-container">
                {sections[selectedSection] ? (
                  sections[selectedSection]()
                ) : (
                  <div className="default-content">
                    <h3>Welcome to EDCC Portal</h3>
                    <p>Please select an option from the sidebar</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="modal-content-aiota-member"
        show={showSignOutModal}
        onHide={handleSignOutCancel}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Sign Out</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          Are you sure you want to sign out?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleSignOutCancel}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleSignOutConfirm}>
            Sign Out
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Missing Documents Validation Modal */}
      <Modal
        className="modal-content-aiota-member"
        show={showMissingDocsModal}
        onHide={() => setShowMissingDocsModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Missing Required Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>The following required documents are missing:</p>
          <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
            {missingDocsList.map((docName, index) => (
              <li key={index} style={{ color: "#dc3545", marginBottom: "6px" }}>
                {docName}
              </li>
            ))}
          </ul>
          <p style={{ marginTop: "15px", fontWeight: "500" }}>
            All documents are required. Please upload the missing documents before submitting.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowMissingDocsModal(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EDCCProfilePage;
